import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  it: {
    // Navigation
    dashboard: "Dashboard",
    restaurants: "Ristoranti",
    comparison: "Confronto Sedi",
    reviews: "Recensioni",
    sofia_ai: "Sofia AI",
    settings: "Impostazioni",
    menu: "Menu",
    staff: "Personale",
    expenses: "Spese",
    alerts: "Avvisi",
    logout: "Esci",
    integrations: "Integrazioni",
    competitors: "Competitors",
    team: "Team",
    faq: "FAQ",
    reports: "Report",

    // Dashboard
    overview: "Panoramica",
    total_revenue: "Fatturato Totale",
    total_reviews: "Recensioni Totali",
    avg_rating: "Rating Medio",
    profit_margin: "Margine di Profitto",
    food_cost: "Food Cost",
    labor_cost: "Costo Personale",
    revenue_by_restaurant: "Fatturato per Ristorante",
    profit_margin_chart: "Margine di Profitto (%)",
    your_restaurants: "I tuoi ristoranti",
    view_all: "Vedi tutti",
    revenue: "Fatturato",
    vs_last_month: "vs mese prec.",
    health_score: "Score Salute Ristoranti",

    // Common
    save: "Salva",
    cancel: "Annulla",
    delete: "Elimina",
    edit: "Modifica",
    add: "Aggiungi",
    search: "Cerca",
    filter: "Filtra",
    export: "Esporta",
    import_label: "Importa",
    loading: "Caricamento...",
    no_data: "Nessun dato disponibile",
    back: "Indietro",
    confirm: "Conferma",
    close: "Chiudi",
    name: "Nome",
    price: "Prezzo",
    cost: "Costo",
    margin: "Margine",
    category: "Categoria",
    description: "Descrizione",
    available: "Disponibile",
    not_available: "Non disponibile",
    total: "Totale",
    average: "Media",
    select: "Seleziona...",
    actions: "Azioni",
    error: "Errore",
    error_loading: "Errore nel caricamento dei dati",
    error_saving: "Errore nel salvataggio",
    error_deleting: "Errore nell'eliminazione",
    members: "dipendenti",
    excellent: "Eccellente",
    good: "Buono",
    fair: "Discreto",
    poor: "Scarso",
    download: "Scarica",
    generate: "Genera",
    daily: "Giornaliero",
    weekly: "Settimanale",

    // Menu
    menu_management: "Gestione Menu",
    menu_categories: "Categorie Menu",
    manage_categories: "Gestisci categorie",
    add_remove_categories: "Aggiungi o rimuovi le categorie",
    add_dish: "Aggiungi piatto",
    edit_dish: "Modifica piatto",
    new_dish: "Nuovo piatto",
    dish_name: "Nome piatto",
    enter_dish_details: "Inserisci i dettagli del piatto",
    selling_price: "Prezzo di vendita",
    dish_cost: "Costo piatto",
    avg_price: "Prezzo Medio",
    avg_margin: "Margine Medio",
    total_dishes: "Piatti Totali",
    empty_menu: "Menu vuoto",
    empty_menu_desc: "Aggiungi i piatti del menu per tracciare i margini e ricevere suggerimenti AI sui prezzi.",
    add_first_dish: "Aggiungi primo piatto",
    new_category: "Nome nuova categoria...",
    select_category: "Seleziona categoria...",
    dish_updated: "Piatto aggiornato!",
    dish_added: "Piatto aggiunto!",
    dish_deleted: "Piatto eliminato",
    confirm_delete_dish: "Sei sicuro di voler eliminare questo piatto?",
    category_added: "Categoria aggiunta!",
    category_deleted: "Categoria eliminata",
    confirm_delete_category: "Eliminare questa categoria?",

    // Staff
    staff_management: "Gestione Personale",
    staff_categories: "Categorie Personale",
    manage_depts_roles: "Gestisci reparti e ruoli del personale",
    manage_staff_categories: "Gestisci categorie",
    add_member: "Aggiungi dipendente",
    new_member: "Nuovo dipendente",
    edit_member: "Modifica dipendente",
    enter_staff_details: "Inserisci i dati del dipendente",
    first_name: "Nome",
    last_name: "Cognome",
    role: "Ruolo",
    department: "Reparto",
    contract_type: "Tipo contratto",
    gross_salary: "Stipendio Lordo",
    net_salary: "Stipendio Netto",
    gross_monthly: "Lordo/Mese",
    net_monthly: "Netto/Mese",
    gross: "Lordo",
    net: "Netto",
    hours_week: "Ore/Settimana",
    hire_date: "Data assunzione",
    active: "Attivo",
    departments: "Reparti",
    roles: "Ruoli",
    total_staff: "Totale Dipendenti",
    total_payroll: "Costo Totale Personale",
    active_employees: "Dipendenti Attivi",
    terminated_employees: "Licenziati",
    no_employees: "Nessun dipendente",
    no_employees_desc: "Aggiungi i dipendenti per tracciare i costi del personale.",
    add_first_member: "Aggiungi primo dipendente",
    no_terminated: "Nessun dipendente licenziato",
    category_name: "Nome categoria...",
    staff_updated: "Dipendente aggiornato!",
    staff_added: "Dipendente aggiunto!",
    staff_deleted: "Dipendente eliminato",
    confirm_delete_staff: "Sei sicuro di voler eliminare questo dipendente?",
    avg_hourly_cost: "Costo Orario Medio",
    hourly_cost_label: "Costo/Ora",
    terminate: "Licenzia",
    terminate_employee: "Licenziamento Dipendente",
    termination_date: "Data licenziamento",
    termination_date_required: "La data di licenziamento è obbligatoria",
    severance_pay: "Buonuscita",
    severance_description: "Importo TFR / liquidazione / buonuscita da corrispondere al dipendente",
    confirm_termination: "Conferma Licenziamento",
    terminated: "Licenziato",
    terminated_on: "Licenziato il",
    terminated_count: "licenziati",
    staff_terminated: "Dipendente licenziato",

    // Expenses
    expense_management: "Gestione Spese",
    add_expense: "Aggiungi Spesa",
    expense_categories: "Categorie Spese",
    fixed_expenses: "Spese Fisse",
    variable_expenses: "Spese Variabili",
    total_expenses: "Totale Spese",
    monthly_filter: "Filtra per mese",
    expense_breakdown: "Ripartizione Spese",

    // Restaurants
    add_restaurant: "Aggiungi ristorante",
    single_account: "Account singolo - 1 ristorante",
    multi_account: "Gestisci i tuoi ristoranti e le loro sedi",
    restaurant_details: "Dettagli Ristorante",
    financial_metrics: "Metriche Finanziarie",

    // Integrations
    integrations_title: "Integrazioni",
    configure_connections: "Configura le connessioni e importa i tuoi dati",
    csv_import: "Importa da CSV",
    manual_import: "Aggiungi recensione manuale",
    configured: "Configurato",
    not_configured: "Non configurato",
    imported_reviews: "recensioni importate",
    save_all: "Salva tutte le configurazioni",

    // Competitors
    competitor_analysis: "Analisi Competitor",
    compare_desc: "Confronta prezzi, rating e posizionamento",
    add_competitor: "Aggiungi competitor",
    no_competitors: "Nessun competitor",
    positioning: "Posizionamento",
    rating_comparison: "Confronto Rating",
    price_comparison: "Confronto Prezzi",
    overview_tab: "Panoramica",
    ratings_tab: "Rating",
    prices_tab: "Prezzi",
    detail_tab: "Dettaglio",
    strengths: "Punti di forza",
    weaknesses: "Punti deboli",
    price_range: "Fascia prezzo",
    website: "Sito web",

    // AI
    sofia_title: "Sofia",
    sofia_subtitle: "La tua assistente intelligente per ottimizzare il ristorante",
    analyze_reviews: "Analizza Recensioni",
    optimize_pricing: "Ottimizza Prezzi",
    analyze_performance: "Analisi Performance",
    analyze_menu: "Ottimizza Menu",
    start_analysis: "Avvia analisi",
    analyzing: "Sofia sta analizzando...",
    analysis_complete: "Analisi completata",
    recommendations: "Raccomandazioni",
    sofia_analysis: "Analisi di Sofia",
    sofia_opinion: "Parere di Sofia",
    sofia_report: "Report di Sofia",

    // Auth
    login: "Accedi",
    register: "Registrati",
    email: "Email",
    password: "Password",
    your_name: "Il tuo nome",
    company_name: "Nome azienda",
    account_type: "Tipo account",
    single_type: "Singolo",
    single_desc: "Un ristorante",
    multi_type: "Multi-sede",
    multi_desc: "Più ristoranti",
    
    // Extra
    refresh: "Aggiorna",
    load_demo: "Carica dati demo",
    demo_loaded: "Dati demo caricati con successo!",
    no_restaurants_yet: "Nessun ristorante ancora",
    no_restaurants_desc: "Inizia aggiungendo il tuo primo ristorante o carica i dati demo per esplorare le funzionalità.",

    // Settings
    settings_title: "Impostazioni",
    general_settings: "Impostazioni Generali",
    language: "Lingua",
    currency: "Valuta",
    profile: "Profilo",
    profile_info: "Informazioni del tuo account",
    manage_account: "Gestisci il tuo account",
    member_since: "Membro dal",
    company: "Azienda",
    select_currency_desc: "Seleziona la valuta per tutti gli importi",
    theme: "Tema",
    theme_desc: "Scegli tra modalita chiara e scura",
    danger_zone: "Zona Pericolosa",
    irreversible_actions: "Azioni irreversibili",
    logout_account: "Esci dall'account",
    logout_desc: "Verrai disconnesso da questa sessione",
    currency_changed: "Valuta cambiata in",
    
    // Alerts
    alert_settings: "Impostazioni Avvisi",
    food_cost_threshold: "Soglia Food Cost (%)",
    menu_avg_fc_threshold: "FC% Media Menu",
    margin_threshold: "Soglia Margine (%)",
    rating_threshold: "Soglia Rating",
    break_even_alert: "Alert Break-Even Giornaliero",
    break_even_alert_desc: "Notifica quando l'incasso giornaliero e sotto il break-even",
    inventory_discrepancy_threshold: "Soglia Discrepanza Inventario (%)",
    discrepancy_threshold_desc: "Differenza % tra acquistato e consumato teorico per ingrediente",
    email_notifications: "Notifiche Email",
    in_app_notifications: "Notifiche In-App",

    // CRM & Prospects
    crm_title: "CRM & Outreach",
    crm_subtitle: "Pipeline di vendita, contatti e AI coach",
    tab_prospects: "Prospect",
    tab_search_city: "Cerca Citta",
    tab_import: "Importa",
    tab_campaign: "Campagna",
    tab_ai_coach: "AI Coach",
    total_label: "Totale",
    with_email_label: "Con Email",
    contacted_label: "Contattati",
    priority_a: "Priorita A",
    priority_b: "Priorita B",
    search_placeholder: "Cerca nome, email, citta...",
    all_priorities: "Tutte priorita",
    all_types: "Tutti i tipi",
    selected_count: "selezionati",
    delete_label: "Elimina",
    send_campaign_label: "Invia Campagna",
    contacts_label: "Contatti",
    actions_label: "Azioni",
    add_email: "+ Aggiungi email",
    no_prospects: "Nessun prospect trovato. Usa 'Cerca Citta' o 'Importa' per aggiungerne.",
    // CRM States
    status_da_contattare: "Da contattare",
    status_contattato: "Contattato",
    status_risposta_ricevuta: "Risposta",
    status_call_proposta: "Call proposta",
    status_demo_fissata: "Demo fissata",
    status_demo_fatta: "Demo fatta",
    status_in_valutazione: "In valutazione",
    status_chiuso: "Chiuso",
    status_perso: "Perso",
    status_follow_up_futuro: "Follow-up futuro",
    // Business types
    type_hotel: "Hotel",
    type_hotel_luxury: "Hotel Luxury",
    type_ristorante_indipendente: "Rist. Indipendente",
    type_italian_independent: "Italiano Indip.",
    type_catena: "Catena",
    type_franchising_master: "Franchising / Master",
    type_resort: "Resort",
    type_michelin: "Michelin / Fine Dining",
    type_thai_fine_dining: "Thai Fine Dining",
    type_thai_local: "Thai Local / Street Food",
    type_other: "Altro",
    // Franchise & Master translations
    franchise_nav: "Franchising",
    franchise_management_title: "Gestione Franchising",
    franchise_management_desc: "Crea e gestisci gruppi franchising, master user e abbonamenti personalizzati",
    franchise_add_group: "Nuovo Gruppo",
    franchise_new: "Nuovo Gruppo Franchising",
    franchise_edit: "Modifica Gruppo",
    franchise_name: "Nome Gruppo",
    franchise_brand: "Nome Brand",
    franchise_contact_person: "Referente",
    franchise_contact_email: "Email Referente",
    franchise_region: "Regione",
    franchise_payment_mode: "Modalità Pagamento",
    franchise_master_pays: "Paga il Master",
    franchise_individual_pays: "Pagano i Singoli",
    franchise_custom_plan: "Piano Personalizzato",
    franchise_price_monthly: "Prezzo Mensile (€)",
    franchise_price_label: "Etichetta Prezzo",
    franchise_max_outlets: "Max Outlet",
    franchise_plan_notes: "Note trattativa",
    franchise_plan_notes_hint: "Condizioni speciali, sconti, ecc.",
    franchise_create: "Crea Gruppo",
    franchise_update: "Aggiorna",
    franchise_created: "Gruppo creato!",
    franchise_updated: "Gruppo aggiornato!",
    franchise_deleted: "Gruppo eliminato",
    franchise_confirm_delete: "Sei sicuro di voler eliminare questo gruppo?",
    franchise_no_groups: "Nessun gruppo franchising. Creane uno!",
    franchise_master_user: "Utente Master",
    franchise_no_master: "Nessun Master",
    franchise_create_master: "Crea Utente Master",
    franchise_master_name: "Nome Master",
    franchise_company: "Società",
    franchise_master_created: "Utente master creato!",
    franchise_view_dashboard: "Vedi Dashboard",
    franchise_outlets: "Punti Vendita",
    franchise_no_outlets: "Nessun punto vendita collegato",
    franchise_add_outlet: "Aggiungi punto vendita...",
    franchise_restaurant_added: "Punto vendita aggiunto!",
    master_dashboard_nav: "Dashboard Master",
    master_dashboard_title: "Dashboard Master Franchisee",
    master_no_data: "Nessun dato disponibile",
    master_total_outlets: "Punti Vendita",
    master_total_revenue: "Fatturato Totale",
    master_avg_food_cost: "Food Cost Medio",
    master_total_alerts: "Alert Attivi",
    master_outlets_performance: "Performance Punti Vendita",
    master_outlet_name: "Punto Vendita",
    master_revenue: "Fatturato",
    master_food_cost: "Food Cost",
    master_margin: "Margine",
    master_rating: "Rating",
    master_alerts_col: "Alert",
    master_actions: "Azioni",
    master_send_message_to: "Invia messaggio a",
    master_message_placeholder: "Scrivi il messaggio per il punto vendita...",
    master_send: "Invia",
    master_message_sent: "Messaggio inviato!",
    master_message_history: "Storico messaggi",
    master_alert_message_prefix: "Alert rilevato per",
    master_alert_message_suffix: "Si prega di verificare e apportare correttivi immediati.",
    master_threshold: "soglia",
    master_no_outlets: "Nessun punto vendita collegato al tuo gruppo",
    master_tab_overview: "Panoramica",
    master_tab_report: "Report Consolidato",
    master_report_title: "Report Consolidato Franchise",
    master_report_trend: "Trend",
    master_report_labor: "Costo Personale",
    master_report_msgs: "Messaggi",
    master_menu_analysis: "Analisi Menu",
    master_menu_total: "Totale",
    master_menu_item: "Piatto",
    master_menu_price: "Prezzo",
    master_menu_margin: "Margine",
    master_menu_sales: "Vendite/mese",
    master_menu_class: "Classe",
    master_menu_no_items: "Nessun piatto nel menu",
    master_menu_send_suggestion: "Invia suggerimento ottimizzazione menu",
    master_menu_suggestion_hint: "Es: I piatti Dog dovrebbero essere rimossi o riprezziati...",
    master_suggestion_sent: "Suggerimento inviato al punto vendita!",
    // Detail panel
    pipeline_status: "Stato Pipeline",
    contact_person: "Contatto principale",
    contact_role_label: "Ruolo",
    business_type: "Tipo business",
    priority_label: "Priorita",
    notes_strategic: "Note / Perche e strategico",
    followup_1: "Follow-up 1",
    followup_2: "Follow-up 2",
    register_contact: "Registra contatto",
    contact_outcome: "Esito",
    contact_notes: "Note aggiuntive...",
    status_unchanged: "Stato invariato",
    register_btn: "Registra",
    contact_history: "Storico contatti",
    no_contacts: "Nessun contatto registrato",
    generate_with_ai: "Genera email con AI Coach",
    // Channels
    channel_email: "Email",
    channel_telefono: "Telefono",
    channel_whatsapp: "WhatsApp",
    channel_linkedin: "LinkedIn",
    channel_di_persona: "Di persona",
    // AI Coach
    ai_coach_title: "AI Email Coach",
    ai_stage_label: "Stadio della vendita",
    ai_stage_primo: "1. Primo contatto",
    ai_stage_primo_desc: "Ottenere una risposta",
    ai_stage_follow_up: "2. Follow-up",
    ai_stage_follow_up_desc: "Proporre mini-call",
    ai_stage_dopo_risposta: "3. Dopo risposta",
    ai_stage_dopo_risposta_desc: "Fissare la demo",
    ai_stage_post_demo: "4. Post-demo",
    ai_stage_post_demo_desc: "Chiudere",
    ai_stage_ultimo: "5. Ultimo tentativo",
    ai_stage_ultimo_desc: "Chiudere con rispetto",
    ai_lang_label: "Lingua:",
    ai_second_lang: "+ Seconda lingua:",
    ai_none: "Nessuna",
    ai_generate: "Genera",
    ai_generating: "Sofia sta scrivendo...",
    ai_subject_label: "Oggetto:",
    ai_body_label: "Body:",
    ai_translation: "Traduzione:",
    ai_use_campaign: "Usa per Campagna",
    ai_copy: "Copia",
    ai_sofia_tip: "Consiglio di Sofia",
    ai_no_prospect: "Clicca sull'icona AI nella lista prospect per generare un'email personalizzata",
    ai_go_list: "Vai alla Lista",
    sofia_analyze_btn: "Analizza Prospect",
    sofia_analyzing: "Sofia sta analizzando...",
    sofia_analysis_title: "Analisi di Sofia per questo Prospect",
    sofia_analysis_summary: "Riepilogo",
    sofia_email_suggestions: "Suggerimenti per l'email",
    sofia_tone_recommendation: "Tono consigliato",
    sofia_key_pain_points: "Pain points chiave",
    sofia_custom_hook: "Hook personalizzato",
    sofia_analysis_hint: "Prima di generare l'email, chiedi a Sofia di analizzare questo prospect per personalizzare al meglio il messaggio.",
    sofia_ai_feature_desc: "Sofia AI integrata: monitoraggio KPI, alert automatici, stress test, menu engineering",
    sofia_save_analysis: "Salva Analisi nel Prospect",
    sofia_analysis_saved: "Analisi salvata!",
    sofia_saved_analysis_label: "Analisi salvata di Sofia",
    sofia_saved_on: "Salvata il",
    sofia_selected: "selezionati",
    sofia_select_hint: "Seleziona i suggerimenti da inserire nell'email generata dall'AI Coach",
    sofia_insert_in_email: "Inserisci nell'email",
    sofia_inserted_in_email: "Suggerimenti inseriti nell'email!",
    sofia_select_at_least_one: "Seleziona almeno un suggerimento",
    sofia_email_preview: "Nell'email dirà",
    check_now: "Controlla Ora",
    checking: "Controllo...",

    // Franchise Detection (Search)
    franchise_detected_title: "Franchise Rilevati",
    franchise_brands_found: "brand con piu sedi",
    franchise_detected_desc: "Sofia ha rilevato brand con piu punti vendita nella stessa area. Questi prospect sono etichettati con priorita F (Franchise) — contatta il Master/Holding!",
    franchise_locations_in_area: "sedi nell'area",
    total_reviews_short: "recensioni totali",
    franchise_master_target: "Target: Master",
    franchise_results_label: "risultati",
    franchise_select_all: "Seleziona Tutti",
    franchise_save_prospects: "Salva Prospect",
    franchise_label: "FRANCHISE",
    franchise_locations_detected: "sedi rilevate nella zona",
    priority_f: "Priorita F (Franchise)",

    // Platform Benchmark
    platform_benchmark_title: "Benchmark Piattaforma",
    platform_benchmark_subtitle: "Confronto con i ristoranti della piattaforma",
    platform_benchmark_btn: "Ranking Globale",
    platform_your_score: "Il Tuo Punteggio",
    platform_score_desc: "Posizione complessiva rispetto a tutti i ristoranti sulla piattaforma",
    platform_total_restaurants: "Ristoranti totali",
    platform_seg_global: "Tutti",
    platform_seg_city: "Per citta",
    platform_seg_cuisine: "Per tipologia",
    platform_your_value: "Il Tuo",
    platform_avg: "Media",
    platform_interpretation_title: "Come leggere il benchmark",
    platform_interpretation_desc: "Ogni KPI mostra la tua posizione rispetto alla media della piattaforma. Il pallino colorato indica dove ti trovi nel range P25-P75 (fascia centrale dei ristoranti). Piu il pallino e verde, migliore e la tua performance.",
    platform_tier_excellent: "Eccellente",
    platform_tier_average: "Nella media",
    platform_tier_improve: "Da migliorare",
    kpi_food_cost_pct: "Food Cost %",
    kpi_food_cost_pct_desc: "Costo materie prime sul fatturato",
    kpi_labor_cost_pct: "Costo Personale %",
    kpi_labor_cost_pct_desc: "Costo del lavoro sul fatturato",
    kpi_profit_margin: "Margine di Profitto %",
    kpi_profit_margin_desc: "Utile netto in percentuale",
    kpi_revenue: "Fatturato Medio Mensile",
    kpi_revenue_desc: "Entrate medie mensili",
    kpi_rent_pct: "Incidenza Affitto %",
    kpi_rent_pct_desc: "Costo affitto sul fatturato",
    refresh: "Aggiorna",
    platform_lower_better: "(piu basso = meglio)",
    platform_higher_better: "(piu alto = meglio)",

    // Reviews
    reviews_title: "Recensioni",
    source: "Fonte",
    rating: "Rating",
    date: "Data",
    text: "Testo",
    author: "Autore",

    // Stress Test / Viability
    stress_test_title: "Stress Test & Simulatore",
    stress_test_subtitle: "Decision Intelligence per la sostenibilita del tuo ristorante",
    stress_test_tab: "Stress Test",
    simulator_tab: "Simulatore",
    run_analysis: "Avvia Analisi",
    sofia_analyzes_desc: "Sofia analizza se il tuo locale è sostenibile in base ai numeri reali",
    use_existing_staff: "Usa dati personale esistenti",
    avg_ticket: "Scontrino Medio",
    covers_per_day: "Coperti / Giorno",
    working_days: "Giorni Lavorativi / Mese",
    food_cost_pct: "Food Cost %",
    staff_count: "N. Dipendenti",
    avg_staff_cost: "Costo Medio Dip./Mese",
    monthly_rent: "Affitto Mensile",
    utilities_month: "Utenze / Mese",
    marketing_month: "Marketing / Mese",
    other_expenses: "Altre Spese / Mese",
    loan_payments: "Rate Prestiti / Mese",
    break_even: "Break Even",
    current_covers: "Coperti Attuali",
    monthly_revenue: "Fatturato/Mese",
    monthly_profit: "Profitto/Mese",
    annual_revenue: "anno",
    annual_profit: "anno",
    total_costs: "Costi totali",
    profit: "Profitto",
    scenario_desc_label: "Descrivi lo scenario",
    scenario_placeholder: "Es: Alzo lo scontrino medio a 30 e assumo un cameriere...",
    new_avg_ticket: "Nuovo Scontrino Medio",
    new_covers: "Nuovi Coperti/Giorno",
    new_staff_count: "Nuovo N. Dipendenti",
    new_staff_cost: "Nuovo Costo Dip./Mese",
    new_food_cost: "Nuovo Food Cost %",
    new_rent: "Nuovo Affitto",
    run_simulation: "Simula Scenario",
    base_data: "Dati base attuali:",
    run_stress_first: "Esegui prima lo Stress Test",
    what_if_desc: "Cosa succede se cambio qualcosa? Inserisci solo i valori che vuoi modificare",
    base_scenario: "Scenario Base",
    new_scenario: "Nuovo Scenario",
    impact: "Impatto",
    monthly_impact: "mensile",
    annual_impact: "annuale",
    simulate_scenario: "Simula Scenario",
    current_status: "Situazione Attuale",

    // Daily Tracker
    daily_tracker_title: "Tracker Giornaliero",
    daily_tracker_subtitle: "Registra incassi e monitora le performance quotidiane",
    add_entry: "Aggiungi",
    total_revenue_daily: "Fatturato Totale",
    daily_average: "Media Giornaliera",
    avg_ticket_daily: "Ticket Medio",
    total_clients: "Clienti Totali",
    receipts: "Scontrini",
    clients: "Clienti",
    revenue_amount: "Incasso",
    last_days_chart: "Andamento Ultimi Giorni",
    performance_score: "Score Performance",
    weekly_summary: "Riepilogo Settimanale",
    break_even_line: "Break-even",

    // Benchmark
    benchmark_title: "Market Benchmark",
    benchmark_subtitle: "Confronta i tuoi KPI con i benchmark di mercato italiano",
    select_type: "Seleziona tipologia",
    your_value: "Il tuo valore",
    benchmark_value: "Benchmark",
    above_avg: "Sopra la media",
    below_avg: "Sotto la media",
    on_target: "In linea",
    position_score: "Score Posizionamento",

    // Operations
    operations_title: "Operations",
    operations_subtitle: "Analisi operativa del ristorante",
    staff_optimizer: "Staff Optimizer",
    menu_engineering: "Menu Engineering",
    waste_tracker: "Waste Tracker",

    // Month Comparison
    report_audit_title: "Report & Audit",
    month_vs_month: "Mese vs Mese",
    menu_audit: "Menu Audit",
    previous: "Prima",
    total_clients_label: "Clienti Totali",
    expense_changes: "Spese: Variazioni per Categoria",
    no_expense_data: "Nessuna spesa registrata per il confronto",
    alert_changes: "Alert Variazioni",
    insufficient_data: "Dati insufficienti per il confronto",
    insufficient_data_desc: "Inserisci incassi giornalieri e spese per vedere il confronto mese su mese",
    run_audit: "Esegui Audit Menu",
    audit_running: "Analisi in corso...",
    audit_complete: "Menu audit completato!",
    last_audit: "Ultimo Audit",
    dishes: "Piatti",
    avg_food_cost: "Food Cost Medio",
    issues_found: "Problemi Trovati",
    high_food_cost: "Food Cost Alto",
    low_margin: "Margine Basso",
    audit_history: "Storico Audit",
    no_audit: "Nessun audit disponibile",
    no_audit_desc: "Esegui il primo audit per analizzare il tuo menu",
    issues: "problemi",

    // PDF Reports
    pdf_reports: "Report PDF",
    generate_daily_pdf: "Genera Report Giornaliero",
    generate_weekly_pdf: "Genera Report Settimanale",
    generating_pdf: "Generazione PDF in corso...",
    pdf_ready: "Report PDF pronto!",
    download_pdf: "Scarica PDF",
    daily_report: "Report Giornaliero",
    weekly_report: "Report Settimanale",
    report_generated: "Report generato",

    // FAQ
    faq_title: "Domande Frequenti",
    faq_subtitle: "Risposte alle domande più comuni su RistoMetrix",
    faq_stress_q: "Come funziona lo Stress Test?",
    faq_stress_a: "Lo Stress Test analizza la sostenibilità finanziaria del tuo ristorante. Inserisci i dati reali (scontrino medio, coperti, costi del personale, affitto, ecc.) e Sofia AI calcola il break-even, il profitto mensile e annuale, e fornisce un verdetto sulla viabilità del tuo locale.",
    faq_simulator_q: "Come funziona il Simulatore di Scenario?",
    faq_simulator_a: "Il Simulatore ti permette di fare analisi 'what-if'. Parti dai dati dello Stress Test e modifichi uno o più parametri (es: alzi il ticket medio, assumi un dipendente). Sofia calcola l'impatto finanziario e ti dice se la modifica è vantaggiosa.",
    faq_daily_q: "Come uso il Tracker Giornaliero?",
    faq_daily_a: "Registra ogni giorno l'incasso, il numero di scontrini e i clienti. Il sistema calcola automaticamente il ticket medio e monitora le performance con uno score giornaliero, confrontandole con la media e il break-even.",
    faq_benchmark_q: "Come funziona il Benchmark di Mercato?",
    faq_benchmark_a: "Confronta i KPI del tuo ristorante (food cost, margine, ticket medio, ecc.) con i benchmark del settore ristorativo italiano per la tua tipologia di cucina. Ricevi uno score di posizionamento da 0 a 100.",
    faq_menu_audit_q: "Cos'è il Menu Audit?",
    faq_menu_audit_a: "Il Menu Audit analizza automaticamente ogni piatto del tuo menu: verifica il food cost, il margine, e identifica piatti problematici. Sofia AI genera un report con raccomandazioni specifiche per ottimizzare il menu.",
    faq_menu_eng_q: "Cos'è il Menu Engineering?",
    faq_menu_eng_a: "Il Menu Engineering classifica i piatti del menu in 4 categorie (Star, Puzzle, Plowhorse, Dog) in base a popolarità e margine. Ricevi azioni consigliate per ogni piatto: promuovere, ripensare il prezzo, rimuovere dal menu, ecc.",
    faq_currency_q: "Come cambio la valuta?",
    faq_currency_a: "Vai in Impostazioni e seleziona la valuta desiderata. Il simbolo si aggiornerà automaticamente su tutte le pagine dell'applicazione. Sono supportate 10 valute: EUR, USD, GBP, THB, CHF, JPY, AUD, CAD, AED, SGD.",
    faq_dark_q: "Come attivo il Dark Mode?",
    faq_dark_a: "Puoi attivare il Dark Mode dal pulsante nella barra laterale (icona luna/sole) oppure dalla pagina Impostazioni nella sezione Tema.",
    faq_staff_q: "Come gestisco il personale?",
    faq_staff_a: "Nella sezione Personale puoi aggiungere dipendenti con stipendio lordo/netto, ore settimanali, reparto e ruolo. Puoi anche licenziare dipendenti con calcolo del TFR. Lo Staff Optimizer calcola il numero ottimale di personale per cucina, sala e bar.",
    faq_pdf_q: "Come genero i report PDF?",
    faq_pdf_a: "Nella pagina Report & Audit, nella sezione Report PDF, puoi generare report giornalieri o settimanali. Il report include un riepilogo delle performance, grafici e analisi di Sofia AI.",

    // Expense Analysis & Alerts
    expense_analysis: "Analisi Spese",
    expense_analysis_subtitle: "Analisi avanzata costi, soglie e redditività per area",
    expense_alerts_tab: "Alert Spese",
    area_analysis_tab: "Analisi per Area",
    no_alerts: "Nessun alert attivo",
    no_alerts_desc: "Tutti i parametri sono entro le soglie. Ottimo lavoro!",
    alert_severity_high: "Critico",
    alert_severity_medium: "Attenzione",
    threshold: "Soglia",
    current_value: "Valore attuale",
    total_revenue_label: "Fatturato Totale",
    total_expenses_label: "Spese Totali",
    total_staff_cost_label: "Costo Personale",
    net_margin_label: "Margine Netto",
    department_label: "Reparto",
    staff_cost_label: "Costo Personale",
    estimated_revenue_label: "Fatturato Stimato",
    profit_label: "Profitto",
    cost_pct_label: "Costo/Fatturato",
    area_status_ok: "OK",
    area_status_warning: "Attenzione",
    area_status_critical: "Critico",
    area_status_no_revenue: "Nessuna vendita",
    no_area_data: "Nessun dato area disponibile",
    no_area_data_desc: "Inserisci vendite per categoria nel Tracker Giornaliero e aggiungi il personale per analizzare le aree.",
    category_sales_title: "Vendite per Categoria",
    category_sales_desc: "Registra il numero di piatti venduti per categoria",
    dish_sales_title: "Vendite per Piatto (dal Menu)",
    dish_sales_desc: "Quantita vendute per singolo piatto",
    dishes_sold: "piatti venduti",
    revenue_from_dishes: "Ricavo piatti",
    sold: "venduti",
    no_menu_items_title: "Nessun piatto nel menu",
    no_menu_items_desc: "Per tracciare le vendite per singolo piatto, inserisci prima il tuo menu. I piatti appariranno qui automaticamente con prezzo e food cost.",
    go_to_menu: "Vai al Menu",
    qty_sold: "Qtà venduta",
    daily_detail: "Dettaglio Giornaliero",
    weekly_summary_title: "Riepilogo Settimanale",
    history_title: "Storico Inserimenti",
    start_tracking: "Inizia il Tracking",
    start_tracking_desc: "Inizia a inserire gli incassi giornalieri per monitorare le performance",
    avg_ticket_label: "Ticket medio",
    spend_per_client: "Spesa/cliente",
    of_average: "della media",
    clients_label: "clienti",
    ticket_label: "ticket",
    below_breakeven: "Sotto break-even",
    avg_daily_label: "media/g",
    days_recorded: "giorni",
    date_range_label: "Intervallo Date",
    range_mode_desc: "I dati verranno inseriti per ogni giorno nell'intervallo selezionato",
    date_from: "Data Inizio",
    date_to: "Data Fine",
    days_label: "gg",
    days_saved: "giorni salvati",
    date_range_error: "La data inizio deve essere prima della data fine",
    date_range_too_long: "Intervallo massimo: 90 giorni",
    income_label: "Incasso",
    receipts_label: "Scontrini",
    avg_ticket_col: "Ticket Medio",
    staff_members_label: "dipendenti",

    // Restaurant Detail
    months_of_data: "mesi di dati",
    financial_data: "Dati Finanziari",
    export_csv: "Esporta CSV",
    add_monthly_data: "Aggiungi dati mensili",
    add_financial_data: "Aggiungi dati finanziari",
    month_yyyy_mm: "Mese (YYYY-MM)",
    rent: "Affitto",
    utilities: "Utenze",
    other_costs: "Altri Costi",
    revenue_profit_trend: "Andamento Fatturato e Profitto",
    cost_breakdown: "Ripartizione Costi (Ultimo mese)",
    month_label: "Mese",
    reviews_by_platform: "Recensioni per Piattaforma",
    recent_reviews: "Recensioni Recenti",
    reviews_count: "recensioni",

    // Team Page
    team_subtitle: "Gestisci i sottoutenti e i loro permessi",
    add_member: "Aggiungi membro",
    edit_member: "Modifica Membro",
    new_member: "Nuovo Membro Team",
    member_subtitle: "Crea un sottoutente con permessi specifici",
    enter_password: "Inserisci una password",
    member_updated: "Membro aggiornato!",
    member_added: "Membro aggiunto al team!",
    member_deleted: "Membro eliminato",
    confirm_delete_member: "Eliminare questo membro del team?",
    name_label: "Nome",
    email_label: "Email",
    password_label: "Password",
    role_label: "Ruolo",
    role_viewer: "Solo Visualizzazione",
    role_viewer_desc: "Solo Visualizzazione - Può solo guardare",
    role_editor: "Editor",
    role_editor_desc: "Editor - Può modificare menu, staff, spese",
    role_admin: "Amministratore",
    role_admin_desc: "Amministratore - Può fare tutto",
    restaurant_access: "Accesso Ristoranti",
    restaurant_access_desc: "Seleziona a quali ristoranti può accedere (vuoto = tutti)",
    no_team_members: "Nessun membro nel team",
    no_team_members_desc: "Aggiungi sottoutenti per dare accesso al tuo team con permessi personalizzati.",
    add_first_member: "Aggiungi primo membro",
    restaurants_count: "ristoranti",

    // Alerts Page
    alerts_title: "Avvisi e Notifiche",
    alerts_subtitle: "Configura gli alert automatici e visualizza le notifiche",
    alert_settings: "Impostazioni Alert",
    alert_settings_desc: "Configura le soglie per gli avvisi automatici",
    food_cost_threshold: "Soglia Food Cost (%)",
    menu_avg_fc_threshold: "FC% Media Menu",
    margin_threshold: "Soglia Margine (%)",
    rating_threshold: "Soglia Rating",
    break_even_alert: "Alert Break-Even Giornaliero",
    break_even_alert_desc: "Notifica quando l'incasso giornaliero e sotto il break-even",
    inventory_discrepancy_threshold: "Soglia Discrepanza Inventario (%)",
    discrepancy_threshold_desc: "Differenza % tra acquistato e consumato teorico per ingrediente",
    alert_if_above: "Alert se superiore",
    alert_if_below: "Alert se inferiore",
    in_app_notifications: "Notifiche In-App",
    in_app_notifications_desc: "Mostra avvisi nella dashboard",
    email_notifications: "Notifiche Email",
    email_notifications_desc: "Ricevi alert via email",
    alerts_list: "Avvisi",
    alerts_history: "Cronologia delle notifiche ricevute",
    mark_all_read: "Segna tutti come letti",
    value_label: "Valore",
    threshold_label: "Soglia",
    no_alerts_history: "Gli avvisi appariranno qui quando i parametri dei tuoi ristoranti supereranno le soglie configurate.",

    // Login Page
    login: "Accedi",
    register: "Registrati",
    welcome_back: "Bentornato",
    login_subtitle: "Accedi al tuo account per gestire i tuoi ristoranti",
    logging_in: "Accesso in corso...",
    login_error: "Errore durante il login",
    create_account: "Crea un account",
    register_subtitle: "Inizia a monitorare le performance dei tuoi ristoranti",
    full_name: "Nome completo",
    company_name: "Nome azienda (opzionale)",
    account_type: "Tipo account",
    single_type: "Singolo",
    single_desc: "Un ristorante",
    multi_type: "Multi-sede",
    multi_desc: "Più ristoranti",
    registering: "Registrazione...",
    register_error: "Errore durante la registrazione",
    hero_title: "Gestisci le performance dei tuoi ristoranti",
    hero_revenue: "Analisi fatturati e costi",
    hero_reviews: "Monitoraggio recensioni",
    hero_multi: "Confronto multi-sede",
    hero_ai: "Suggerimenti AI",

    // Integrations Page
    configured: "Configurato",
    not_configured: "Non configurato",
    syncing: "Sincronizzazione...",
    sync: "Sincronizza",
    import_csv: "Importa CSV",
    import_from_csv: "Importa da CSV",
    import_reviews: "Importa recensioni",
    import_manual_review: "Aggiungi recensione manuale",
    import_review_title: "Importa recensione manuale",
    import_review_desc: "Inserisci i dati della recensione",
    reviews_imported: "recensioni importate",
    platform_label: "Piattaforma",
    platform_origin: "Piattaforma di origine",
    upload_csv: "Carica file CSV",
    paste_csv: "Oppure incolla il contenuto CSV",
    csv_format: "Formato CSV: autore, rating (1-5), data (YYYY-MM-DD), testo",
    importing: "Importazione...",
    import_btn: "Importa",
    import_error: "Errore nell'importazione",
    import_csv_error: "Errore nell'importazione CSV",
    author_label: "Autore",
    text_label: "Testo",
    email_alerts_title: "Notifiche Email",
    email_alerts_desc: "Ricevi avvisi automatici quando le metriche superano le soglie",
    send_test_email: "Invia email di test",
    saving_settings: "Salvataggio...",
    save_all_settings: "Salva tutte le configurazioni",
    google_how_to: "Come collegare Google Reviews:",
    tripadvisor_no_api: "TripAdvisor non offre API pubbliche",
    thefork_no_api: "TheFork non offre API pubbliche",

    // Restaurants Page
    add_restaurant: "Aggiungi ristorante",
    select_placeholder: "Seleziona...",

    // Reviews Page
    select_restaurant: "Seleziona ristorante",

    // Competitors Page
    competitor_data_desc: "Inserisci i dati del competitor per il confronto",
    strengths: "Punti di forza",
    strengths_placeholder: "Cosa fanno bene...",
    weaknesses: "Punti deboli",
    weaknesses_placeholder: "Dove sono deboli...",
    overall_score: "Punteggio complessivo",
    price_comparison: "Confronto Prezzi per Categoria",
    your_price: "Il tuo prezzo",

    // Operations/Waste
    avg_margin_label: "Margine medio",
    avg_price_label: "Prezzo medio",
    add_menu_items_matrix: "Aggiungi piatti al menu per vedere la matrice",
    staff_optimization: "Ottimizzazione Personale",
    avg_hourly_cost: "Costo Orario Medio",
    total_needed: "Totale Necessario",
    staff_cost_day: "Costo personale/giorno",
    cost_per_cover: "Costo per coperto",

    // Viability Test
    enter_data: "Inserisci i dati del ristorante",
    employees_label: "dipendenti",
    avg_cost_label: "costo medio",
    covers_month: "coperti/mese",
    working_days: "giorni lavorativi",
    current_covers: "coperti attuali",
    scenario_desc: "Cosa succede se cambio qualcosa? Inserisci solo i valori che vuoi modificare",

    // Expenses
    all_months: "Tutti i mesi",

    // Auto Reports & Audit
    auto_reports: "Report Automatici",
    auto_reports_desc: "Configura la generazione automatica dei report PDF",
    auto_reports_frequency: "Frequenza",
    auto_reports_daily: "Giornaliero",
    auto_reports_weekly: "Settimanale",
    auto_reports_disabled: "Disattivato",
    auto_reports_saved: "Configurazione report automatici salvata",
    auto_audit: "Audit Menu Automatico",
    auto_audit_desc: "Analisi automatica mensile delle performance del menu",
    auto_audit_enabled: "Audit automatico attivo",
    auto_audit_disabled: "Audit automatico disattivato",
    last_auto_report: "Ultimo report automatico",
    last_auto_audit: "Ultimo audit automatico",
    never: "Mai",
    download_report: "Scarica Report",
    auto_reports_list: "Report Generati",
    no_auto_reports: "Nessun report automatico generato",

    // Food Cost Page
    food_cost_title: "Controllo Food Cost",
    suppliers_tab: "Fornitori",
    ingredients_tab: "Ingredienti",
    invoices_tab: "Fatture",
    monthly_fc_tab: "FC Mensile",
    monthly_area_tab: "FC per Area",
    credit_notes_tab: "Note di Credito",
    scan_invoice: "Scansiona Fattura",
    invoice_analyzed: "Fattura analizzata con successo",
    invoice_saved: "Fattura salvata!",
    add_supplier: "Aggiungi Fornitore",
    supplier_name: "Nome Fornitore",
    contact: "Contatto",
    add_ingredient: "Aggiungi Ingrediente",
    ingredient_name: "Nome Ingrediente",
    unit: "Unita",
    packing: "Confezionamento",
    no_suppliers: "Nessun fornitore",
    no_ingredients: "Nessun ingrediente",
    no_invoices: "Nessuna fattura",
    total_purchases: "Acquisti Totali",
    avg_food_cost_pct: "FC% Medio",
    real_vs_theoretical: "Reale vs Teorico",
    theoretical: "Teorico",
    real: "Reale",
    area: "Area",

    // Cash Flow Simulator
    cash_flow_title: "Simulatore Cash Flow",
    cash_flow_page_title: "Cash Flow",
    revenue_label_full: "Fatturato",
    staff_label_full: "Personale",
    rent_label: "Affitto",
    food_cost_label: "Food Cost",
    marketing_label: "Marketing",
    utilities_label: "Utenze",
    other_label: "Altro",
    ebitda_label: "EBITDA",
    margin_label: "Margine",
    base_scenario_label: "Scenario Base",
    new_scenario_label: "Nuovo Scenario",
    impact_label: "Impatto",
    monthly_label: "Mensile",
    annual_label: "Annuale",
    add_scenario: "Aggiungi Scenario",
    quick_scenarios: "Scenari Rapidi",
    custom_scenario: "Scenario Personalizzato",
    revenue_change: "Variazione Fatturato",
    add_staff: "Aggiungi Personale",
    remove_staff: "Rimuovi Personale",
    cost_per_month: "Costo/mese",
    change_rent: "Modifica Affitto",
    delta: "Delta",
    food_cost_change: "Variazione Food Cost",
    amount: "Importo",
    run_simulation_btn: "Simula",
    simulating: "Simulazione...",
    revenue_vs_costs: "Fatturato vs Linea Costi Giornalieri",
    cost_breakdown_label: "Composizione Costi",

    // Profit & Loss
    profit_loss_title: "Conto Economico",
    gross_revenue_label: "Fatturato Lordo",
    net_revenue: "Fatturato Netto",
    food_cost_pl: "Materie Prime",
    gross_margin: "Margine Lordo",
    staff_cost_pl: "Costo Personale",
    operating_margin: "Margine Operativo",
    rent_pl: "Affitto",
    utilities_pl: "Utenze",
    marketing_pl: "Marketing",
    other_expenses_pl: "Altre Spese",
    iva_label: "IVA",
    vat_label: "VAT",
    vat_settlement: "Liquidazione IVA",
    sales_vat: "IVA Vendite (debito)",
    purchase_vat: "IVA Acquisti (credito)",
    delta_vat: "DELTA IVA da versare",
    no_invoices_vat: "Nessuna fattura registrata per questo mese. Scansiona le fatture per calcolare l'IVA credito reale.",
    net_amount: "Imponibile",
    quarterly_view: "Trimestrale",
    cumulative_view: "Cumulativo",
    kpi_benchmarks: "KPI vs Benchmark",
    benchmark: "Benchmark",
    your_value_label: "Il tuo valore",

    // Staff Analysis
    staff_analysis_title: "Analisi Personale",
    revenue_per_employee: "Fatturato/Dipendente",
    cost_revenue_ratio: "Costo/Fatturato",
    revenue_30d: "Fatturato 30gg",
    pct_revenue: "% Fatturato",

    // Restaurant Detail
    use_existing_costs: "Usa costi gia inseriti (Personale + Spese)",
    gross_revenue_short: "Fatturato Lordo",
    
    // Comparison
    total_revenue_compare: "Fatturato Totale",
    restaurants_label: "Ristoranti",
    health_score_label: "Score Salute Ristoranti",

    // Dashboard extra
    food_cost_health: "Food Cost",
    labor_cost_health: "Personale",
    margin_health: "Margine",
    
    // Menu Engineering
    menu_eng_title: "Menu Engineering",
    stars: "Stars",
    puzzles: "Puzzles",
    plowhorses: "Plowhorses",
    dogs: "Dogs",
    popularity: "Popolarita",
    profitability: "Redditivita",
    high: "Alto",
    low: "Basso",
    keep_promote: "Mantieni e promuovi",
    increase_price: "Aumenta il prezzo",
    reduce_cost: "Riduci il costo",
    consider_removing: "Considera la rimozione",
    
    // Viability Test
    viability_title: "Stress Test & Simulatore",
    kitchen: "Cucina",
    pizzeria: "Pizzeria",
    bar: "Bar",

    // Billing
    annual_billing: "Fatturazione annuale",
    monthly_billing: "Fatturazione mensile",
    payment_success: "Pagamento completato",
    payment_cancel: "Pagamento annullato",
    plan_active: "Piano attivo",
    upgrade: "Upgrade",
    current_plan: "Piano attuale",
    
    // Login
    welcome_back_title: "Bentornato",
    login_subtitle: "Accedi per gestire i tuoi ristoranti",
    register_title: "Crea Account",
    register_subtitle: "Inizia a tracciare le performance del tuo ristorante",

    // SuperAdmin
    users_label: "Utenti",
    total_users: "Utenti Totali",
    active_users: "Utenti Attivi",
    total_restaurants: "Totale Ristoranti",
  },
  en: {
    // Navigation
    dashboard: "Dashboard",
    restaurants: "Restaurants",
    comparison: "Location Comparison",
    reviews: "Reviews",
    sofia_ai: "Sofia AI",
    settings: "Settings",
    menu: "Menu",
    staff: "Staff",
    expenses: "Expenses",
    alerts: "Alerts",
    logout: "Logout",
    integrations: "Integrations",
    competitors: "Competitors",
    team: "Team",
    faq: "FAQ",
    reports: "Reports",

    // Dashboard
    overview: "Overview",
    total_revenue: "Total Revenue",
    total_reviews: "Total Reviews",
    avg_rating: "Avg Rating",
    profit_margin: "Profit Margin",
    food_cost: "Food Cost",
    labor_cost: "Labor Cost",
    revenue_by_restaurant: "Revenue by Restaurant",
    profit_margin_chart: "Profit Margin (%)",
    your_restaurants: "Your restaurants",
    view_all: "View all",
    revenue: "Revenue",
    vs_last_month: "vs last month",
    health_score: "Restaurant Health Scores",

    // Common
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    add: "Add",
    search: "Search",
    filter: "Filter",
    export: "Export",
    import_label: "Import",
    loading: "Loading...",
    no_data: "No data available",
    back: "Back",
    confirm: "Confirm",
    close: "Close",
    name: "Name",
    price: "Price",
    cost: "Cost",
    margin: "Margin",
    category: "Category",
    description: "Description",
    available: "Available",
    not_available: "Not available",
    total: "Total",
    average: "Average",
    select: "Select...",
    actions: "Actions",
    error: "Error",
    error_loading: "Error loading data",
    error_saving: "Error saving",
    error_deleting: "Error deleting",
    members: "members",
    excellent: "Excellent",
    good: "Good",
    fair: "Fair",
    poor: "Poor",
    download: "Download",
    generate: "Generate",
    daily: "Daily",
    weekly: "Weekly",

    // Menu
    menu_management: "Menu Management",
    menu_categories: "Menu Categories",
    manage_categories: "Manage categories",
    add_remove_categories: "Add or remove categories",
    add_dish: "Add dish",
    edit_dish: "Edit dish",
    new_dish: "New dish",
    dish_name: "Dish name",
    enter_dish_details: "Enter dish details",
    selling_price: "Selling price",
    dish_cost: "Dish cost",
    avg_price: "Average Price",
    avg_margin: "Average Margin",
    total_dishes: "Total Dishes",
    empty_menu: "Empty menu",
    empty_menu_desc: "Add menu items to track margins and receive AI pricing suggestions.",
    add_first_dish: "Add first dish",
    new_category: "New category name...",
    select_category: "Select category...",
    dish_updated: "Dish updated!",
    dish_added: "Dish added!",
    dish_deleted: "Dish deleted",
    confirm_delete_dish: "Are you sure you want to delete this dish?",
    category_added: "Category added!",
    category_deleted: "Category deleted",
    confirm_delete_category: "Delete this category?",

    // Staff
    staff_management: "Staff Management",
    staff_categories: "Staff Categories",
    manage_depts_roles: "Manage departments and roles",
    manage_staff_categories: "Manage categories",
    add_member: "Add member",
    new_member: "New member",
    edit_member: "Edit member",
    enter_staff_details: "Enter employee details",
    first_name: "First Name",
    last_name: "Last Name",
    role: "Role",
    department: "Department",
    contract_type: "Contract Type",
    gross_salary: "Gross Salary",
    net_salary: "Net Salary",
    gross_monthly: "Gross/Month",
    net_monthly: "Net/Month",
    gross: "Gross",
    net: "Net",
    hours_week: "Hours/Week",
    hire_date: "Hire Date",
    active: "Active",
    departments: "Departments",
    roles: "Roles",
    total_staff: "Total Staff",
    total_payroll: "Total Payroll",
    active_employees: "Active Employees",
    terminated_employees: "Terminated",
    no_employees: "No employees",
    no_employees_desc: "Add employees to track staff costs.",
    add_first_member: "Add first member",
    no_terminated: "No terminated employees",
    category_name: "Category name...",
    staff_updated: "Employee updated!",
    staff_added: "Employee added!",
    staff_deleted: "Employee deleted",
    confirm_delete_staff: "Are you sure you want to delete this employee?",
    avg_hourly_cost: "Avg Hourly Cost",
    hourly_cost_label: "Hourly",
    terminate: "Terminate",
    terminate_employee: "Terminate Employee",
    termination_date: "Termination Date",
    termination_date_required: "Termination date is required",
    severance_pay: "Severance Pay",
    severance_description: "Severance / termination pay amount for the employee",
    confirm_termination: "Confirm Termination",
    terminated: "Terminated",
    terminated_on: "Terminated on",
    terminated_count: "terminated",
    staff_terminated: "Employee terminated",

    // Expenses
    expense_management: "Expense Management",
    add_expense: "Add Expense",
    expense_categories: "Expense Categories",
    fixed_expenses: "Fixed Expenses",
    variable_expenses: "Variable Expenses",
    total_expenses: "Total Expenses",
    monthly_filter: "Filter by month",
    expense_breakdown: "Expense Breakdown",

    // Restaurants
    add_restaurant: "Add restaurant",
    single_account: "Single account - 1 restaurant",
    multi_account: "Manage your restaurants and locations",
    restaurant_details: "Restaurant Details",
    financial_metrics: "Financial Metrics",

    // Integrations
    integrations_title: "Integrations",
    configure_connections: "Configure connections and import your data",
    csv_import: "Import from CSV",
    manual_import: "Add manual review",
    configured: "Configured",
    not_configured: "Not configured",
    imported_reviews: "reviews imported",
    save_all: "Save all settings",

    // Competitors
    competitor_analysis: "Competitor Analysis",
    compare_desc: "Compare prices, ratings and positioning",
    add_competitor: "Add competitor",
    no_competitors: "No competitors",
    positioning: "Positioning",
    rating_comparison: "Rating Comparison",
    price_comparison: "Price Comparison",
    overview_tab: "Overview",
    ratings_tab: "Ratings",
    prices_tab: "Prices",
    detail_tab: "Detail",
    strengths: "Strengths",
    weaknesses: "Weaknesses",
    price_range: "Price range",
    website: "Website",

    // AI
    sofia_title: "Sofia",
    sofia_subtitle: "Your smart assistant to optimize your restaurant",
    analyze_reviews: "Analyze Reviews",
    optimize_pricing: "Optimize Pricing",
    analyze_performance: "Analyze Performance",
    analyze_menu: "Optimize Menu",
    start_analysis: "Start analysis",
    analyzing: "Sofia is analyzing...",
    analysis_complete: "Analysis complete",
    recommendations: "Recommendations",
    sofia_analysis: "Sofia's Analysis",
    sofia_opinion: "Sofia's Opinion",
    sofia_report: "Sofia's Report",

    // Auth
    login: "Login",
    register: "Register",
    email: "Email",
    password: "Password",
    your_name: "Your name",
    company_name: "Company name",
    account_type: "Account type",
    single_type: "Single",
    single_desc: "One restaurant",
    multi_type: "Multi-location",
    multi_desc: "Multiple restaurants",
    
    // Extra
    refresh: "Refresh",
    load_demo: "Load demo data",
    demo_loaded: "Demo data loaded successfully!",
    no_restaurants_yet: "No restaurants yet",
    no_restaurants_desc: "Start by adding your first restaurant or load demo data to explore features.",

    // Settings
    settings_title: "Settings",
    general_settings: "General Settings",
    language: "Language",
    currency: "Currency",
    profile: "Profile",
    profile_info: "Your account information",
    manage_account: "Manage your account",
    member_since: "Member since",
    company: "Company",
    select_currency_desc: "Select the currency for all amounts",
    theme: "Theme",
    theme_desc: "Choose between light and dark mode",
    danger_zone: "Danger Zone",
    irreversible_actions: "Irreversible actions",
    logout_account: "Logout",
    logout_desc: "You will be disconnected from this session",
    currency_changed: "Currency changed to",
    
    // Alerts
    alert_settings: "Alert Settings",
    food_cost_threshold: "Food Cost Threshold (%)",
    menu_avg_fc_threshold: "Menu Avg FC%",
    margin_threshold: "Margin Threshold (%)",
    rating_threshold: "Rating Threshold",
    break_even_alert: "Daily Break-Even Alert",
    break_even_alert_desc: "Notify when daily revenue is below the break-even point",
    inventory_discrepancy_threshold: "Inventory Discrepancy Threshold (%)",
    discrepancy_threshold_desc: "% difference between purchased and theoretical consumption per ingredient",
    email_notifications: "Email Notifications",
    in_app_notifications: "In-App Notifications",

    // CRM & Prospects
    crm_title: "CRM & Outreach",
    crm_subtitle: "Sales pipeline, contacts and AI coach",
    tab_prospects: "Prospects",
    tab_search_city: "Search City",
    tab_import: "Import",
    tab_campaign: "Campaign",
    tab_ai_coach: "AI Coach",
    total_label: "Total",
    with_email_label: "With Email",
    contacted_label: "Contacted",
    priority_a: "Priority A",
    priority_b: "Priority B",
    search_placeholder: "Search name, email, city...",
    all_priorities: "All priorities",
    all_types: "All types",
    selected_count: "selected",
    delete_label: "Delete",
    send_campaign_label: "Send Campaign",
    contacts_label: "Contacts",
    actions_label: "Actions",
    add_email: "+ Add email",
    no_prospects: "No prospects found. Use 'Search City' or 'Import' to add some.",
    status_da_contattare: "To contact",
    status_contattato: "Contacted",
    status_risposta_ricevuta: "Response",
    status_call_proposta: "Call proposed",
    status_demo_fissata: "Demo scheduled",
    status_demo_fatta: "Demo done",
    status_in_valutazione: "Evaluating",
    status_chiuso: "Closed",
    status_perso: "Lost",
    status_follow_up_futuro: "Future follow-up",
    type_hotel: "Hotel",
    type_hotel_luxury: "Luxury Hotel",
    type_ristorante_indipendente: "Independent Rest.",
    type_italian_independent: "Italian Indep.",
    type_catena: "Chain",
    type_franchising_master: "Franchising / Master",
    type_resort: "Resort",
    type_michelin: "Michelin / Fine Dining",
    type_thai_fine_dining: "Thai Fine Dining",
    type_thai_local: "Thai Local / Street Food",
    type_other: "Other",
    franchise_nav: "Franchising",
    franchise_management_title: "Franchise Management",
    franchise_management_desc: "Create and manage franchise groups, master users, and custom subscriptions",
    franchise_add_group: "New Group",
    franchise_new: "New Franchise Group",
    franchise_edit: "Edit Group",
    franchise_name: "Group Name",
    franchise_brand: "Brand Name",
    franchise_contact_person: "Contact Person",
    franchise_contact_email: "Contact Email",
    franchise_region: "Region",
    franchise_payment_mode: "Payment Mode",
    franchise_master_pays: "Master Pays",
    franchise_individual_pays: "Individual Outlets Pay",
    franchise_custom_plan: "Custom Plan",
    franchise_price_monthly: "Monthly Price (€)",
    franchise_price_label: "Price Label",
    franchise_max_outlets: "Max Outlets",
    franchise_plan_notes: "Deal Notes",
    franchise_plan_notes_hint: "Special conditions, discounts, etc.",
    franchise_create: "Create Group",
    franchise_update: "Update",
    franchise_created: "Group created!",
    franchise_updated: "Group updated!",
    franchise_deleted: "Group deleted",
    franchise_confirm_delete: "Are you sure you want to delete this group?",
    franchise_no_groups: "No franchise groups yet. Create one!",
    franchise_master_user: "Master User",
    franchise_no_master: "No Master",
    franchise_create_master: "Create Master User",
    franchise_master_name: "Master Name",
    franchise_company: "Company",
    franchise_master_created: "Master user created!",
    franchise_view_dashboard: "View Dashboard",
    franchise_outlets: "Outlets",
    franchise_no_outlets: "No outlets linked",
    franchise_add_outlet: "Add outlet...",
    franchise_restaurant_added: "Outlet added!",
    master_dashboard_nav: "Master Dashboard",
    master_dashboard_title: "Master Franchisee Dashboard",
    master_no_data: "No data available",
    master_total_outlets: "Outlets",
    master_total_revenue: "Total Revenue",
    master_avg_food_cost: "Avg Food Cost",
    master_total_alerts: "Active Alerts",
    master_outlets_performance: "Outlets Performance",
    master_outlet_name: "Outlet",
    master_revenue: "Revenue",
    master_food_cost: "Food Cost",
    master_margin: "Margin",
    master_rating: "Rating",
    master_alerts_col: "Alerts",
    master_actions: "Actions",
    master_send_message_to: "Send message to",
    master_message_placeholder: "Write a message for this outlet...",
    master_send: "Send",
    master_message_sent: "Message sent!",
    master_message_history: "Message history",
    master_alert_message_prefix: "Alert detected for",
    master_alert_message_suffix: "Please verify and take immediate corrective action.",
    master_threshold: "threshold",
    master_no_outlets: "No outlets linked to your group",
    master_tab_overview: "Overview",
    master_tab_report: "Consolidated Report",
    master_report_title: "Franchise Consolidated Report",
    master_report_trend: "Trend",
    master_report_labor: "Labor Cost",
    master_report_msgs: "Messages",
    master_menu_analysis: "Menu Analysis",
    master_menu_total: "Total",
    master_menu_item: "Dish",
    master_menu_price: "Price",
    master_menu_margin: "Margin",
    master_menu_sales: "Sales/month",
    master_menu_class: "Class",
    master_menu_no_items: "No menu items",
    master_menu_send_suggestion: "Send menu optimization suggestion",
    master_menu_suggestion_hint: "E.g.: Dog items should be removed or repriced...",
    master_suggestion_sent: "Suggestion sent to outlet!",
    pipeline_status: "Pipeline Status",
    contact_person: "Main contact",
    contact_role_label: "Role",
    business_type: "Business type",
    priority_label: "Priority",
    notes_strategic: "Notes / Why strategic",
    followup_1: "Follow-up 1",
    followup_2: "Follow-up 2",
    register_contact: "Register contact",
    contact_outcome: "Outcome",
    contact_notes: "Additional notes...",
    status_unchanged: "Status unchanged",
    register_btn: "Register",
    contact_history: "Contact history",
    no_contacts: "No contacts registered",
    generate_with_ai: "Generate email with AI Coach",
    channel_email: "Email",
    channel_telefono: "Phone",
    channel_whatsapp: "WhatsApp",
    channel_linkedin: "LinkedIn",
    channel_di_persona: "In person",
    ai_coach_title: "AI Email Coach",
    ai_stage_label: "Sales stage",
    ai_stage_primo: "1. First contact",
    ai_stage_primo_desc: "Get a response",
    ai_stage_follow_up: "2. Follow-up",
    ai_stage_follow_up_desc: "Propose mini-call",
    ai_stage_dopo_risposta: "3. After response",
    ai_stage_dopo_risposta_desc: "Schedule demo",
    ai_stage_post_demo: "4. Post-demo",
    ai_stage_post_demo_desc: "Close",
    ai_stage_ultimo: "5. Last attempt",
    ai_stage_ultimo_desc: "Close with respect",
    ai_lang_label: "Language:",
    ai_second_lang: "+ Second language:",
    ai_none: "None",
    ai_generate: "Generate",
    ai_generating: "Sofia is writing...",
    ai_subject_label: "Subject:",
    ai_body_label: "Body:",
    ai_translation: "Translation:",
    ai_use_campaign: "Use for Campaign",
    ai_copy: "Copy",
    ai_sofia_tip: "Sofia's Tip",
    ai_no_prospect: "Click the AI icon in the prospect list to generate a personalized email",
    ai_go_list: "Go to List",
    sofia_analyze_btn: "Analyze Prospect",
    sofia_analyzing: "Sofia is analyzing...",
    sofia_analysis_title: "Sofia's Analysis for this Prospect",
    sofia_analysis_summary: "Summary",
    sofia_email_suggestions: "Email Suggestions",
    sofia_tone_recommendation: "Recommended Tone",
    sofia_key_pain_points: "Key Pain Points",
    sofia_custom_hook: "Custom Hook",
    sofia_analysis_hint: "Before generating the email, ask Sofia to analyze this prospect for the best personalization.",
    sofia_ai_feature_desc: "Built-in Sofia AI: KPI monitoring, automatic alerts, stress tests, menu engineering",
    sofia_save_analysis: "Save Analysis to Prospect",
    sofia_analysis_saved: "Analysis saved!",
    sofia_saved_analysis_label: "Sofia's Saved Analysis",
    sofia_saved_on: "Saved on",
    sofia_selected: "selected",
    sofia_select_hint: "Select the suggestions to include in the email generated by AI Coach",
    sofia_insert_in_email: "Insert in email",
    sofia_inserted_in_email: "Suggestions inserted in email!",
    sofia_select_at_least_one: "Select at least one suggestion",
    sofia_email_preview: "In the email will say",
    check_now: "Check Now",
    checking: "Checking...",

    // Franchise Detection (Search)
    franchise_detected_title: "Franchises Detected",
    franchise_brands_found: "brands with multiple locations",
    franchise_detected_desc: "Sofia detected brands with multiple outlets in this area. These prospects are tagged as priority F (Franchise) — contact the Master/Holding!",
    franchise_locations_in_area: "locations in area",
    total_reviews_short: "total reviews",
    franchise_master_target: "Target: Master",
    franchise_results_label: "results",
    franchise_select_all: "Select All",
    franchise_save_prospects: "Save Prospects",
    franchise_label: "FRANCHISE",
    franchise_locations_detected: "locations detected in area",
    priority_f: "Priority F (Franchise)",

    // Platform Benchmark
    platform_benchmark_title: "Platform Benchmark",
    platform_benchmark_subtitle: "Compare with all platform restaurants",
    platform_benchmark_btn: "Global Ranking",
    platform_your_score: "Your Score",
    platform_score_desc: "Overall position compared to all restaurants on the platform",
    platform_total_restaurants: "Total restaurants",
    platform_seg_global: "All",
    platform_seg_city: "By city",
    platform_seg_cuisine: "By cuisine",
    platform_your_value: "Yours",
    platform_avg: "Average",
    platform_interpretation_title: "How to read the benchmark",
    platform_interpretation_desc: "Each KPI shows your position relative to the platform average. The colored dot indicates where you fall in the P25-P75 range (middle band of restaurants). The greener the dot, the better your performance.",
    platform_tier_excellent: "Excellent",
    platform_tier_average: "Average",
    platform_tier_improve: "Needs improvement",
    kpi_food_cost_pct: "Food Cost %",
    kpi_food_cost_pct_desc: "Cost of ingredients vs revenue",
    kpi_labor_cost_pct: "Labor Cost %",
    kpi_labor_cost_pct_desc: "Staff cost vs revenue",
    kpi_profit_margin: "Profit Margin %",
    kpi_profit_margin_desc: "Net profit percentage",
    kpi_revenue: "Avg Monthly Revenue",
    kpi_revenue_desc: "Average monthly income",
    kpi_rent_pct: "Rent Impact %",
    kpi_rent_pct_desc: "Rent cost vs revenue",
    refresh: "Refresh",
    platform_lower_better: "(lower = better)",
    platform_higher_better: "(higher = better)",
    source: "Source",
    rating: "Rating",
    date: "Date",
    text: "Text",
    author: "Author",

    // Stress Test / Viability
    stress_test_title: "Stress Test & Simulator",
    stress_test_subtitle: "Decision Intelligence for your restaurant's sustainability",
    stress_test_tab: "Stress Test",
    simulator_tab: "Simulator",
    run_analysis: "Run Analysis",
    sofia_analyzes_desc: "Sofia analyzes whether your venue is sustainable based on real numbers",
    use_existing_staff: "Use existing staff data",
    avg_ticket: "Average Ticket",
    covers_per_day: "Covers / Day",
    working_days: "Working Days / Month",
    food_cost_pct: "Food Cost %",
    staff_count: "Number of Staff",
    avg_staff_cost: "Avg Staff Cost/Month",
    monthly_rent: "Monthly Rent",
    utilities_month: "Utilities / Month",
    marketing_month: "Marketing / Month",
    other_expenses: "Other Expenses / Month",
    loan_payments: "Loan Payments / Month",
    monthly_revenue: "Revenue/Month",
    monthly_profit: "Profit/Month",
    annual_revenue: "year",
    annual_profit: "year",
    total_costs: "Total costs",
    profit: "Profit",
    break_even: "Break Even",
    current_covers: "Current Covers",
    scenario_desc_label: "Describe the scenario",
    scenario_placeholder: "E.g.: Raise the average ticket to 30 and hire a waiter...",
    new_avg_ticket: "New Average Ticket",
    new_covers: "New Covers/Day",
    new_staff_count: "New Staff Count",
    new_staff_cost: "New Staff Cost/Month",
    new_food_cost: "New Food Cost %",
    new_rent: "New Rent",
    run_simulation: "Run Simulation",
    base_data: "Current base data:",
    run_stress_first: "Run Stress Test first",
    what_if_desc: "What happens if you change something? Enter only the values you want to modify",
    base_scenario: "Base Scenario",
    new_scenario: "New Scenario",
    impact: "Impact",
    monthly_impact: "monthly",
    annual_impact: "yearly",
    simulate_scenario: "Simulate Scenario",
    current_status: "Current Status",

    // Daily Tracker
    daily_tracker_title: "Daily Tracker",
    daily_tracker_subtitle: "Record income and monitor daily performance",
    add_entry: "Add",
    total_revenue_daily: "Total Revenue",
    daily_average: "Daily Average",
    avg_ticket_daily: "Avg Ticket",
    total_clients: "Total Clients",
    receipts: "Receipts",
    clients: "Clients",
    revenue_amount: "Revenue",
    last_days_chart: "Recent Days Trend",
    performance_score: "Performance Score",
    weekly_summary: "Weekly Summary",
    break_even_line: "Break-even",

    // Benchmark
    benchmark_title: "Market Benchmark",
    benchmark_subtitle: "Compare your KPIs with Italian market benchmarks",
    select_type: "Select type",
    your_value: "Your value",
    benchmark_value: "Benchmark",
    above_avg: "Above average",
    below_avg: "Below average",
    on_target: "On target",
    position_score: "Position Score",

    // Operations
    operations_title: "Operations",
    operations_subtitle: "Restaurant operational analysis",
    staff_optimizer: "Staff Optimizer",
    menu_engineering: "Menu Engineering",
    waste_tracker: "Waste Tracker",

    // Month Comparison
    report_audit_title: "Reports & Audit",
    month_vs_month: "Month vs Month",
    menu_audit: "Menu Audit",
    previous: "Previous",
    total_clients_label: "Total Clients",
    expense_changes: "Expenses: Changes by Category",
    no_expense_data: "No expenses recorded for comparison",
    alert_changes: "Change Alerts",
    insufficient_data: "Insufficient data for comparison",
    insufficient_data_desc: "Enter daily income and expenses to see the month-over-month comparison",
    run_audit: "Run Menu Audit",
    audit_running: "Analysis in progress...",
    audit_complete: "Menu audit completed!",
    last_audit: "Last Audit",
    dishes: "Dishes",
    avg_food_cost: "Avg Food Cost",
    issues_found: "Issues Found",
    high_food_cost: "High Food Cost",
    low_margin: "Low Margin",
    audit_history: "Audit History",
    no_audit: "No audit available",
    no_audit_desc: "Run the first audit to analyze your menu",
    issues: "issues",

    // PDF Reports
    pdf_reports: "PDF Reports",
    generate_daily_pdf: "Generate Daily Report",
    generate_weekly_pdf: "Generate Weekly Report",
    generating_pdf: "Generating PDF...",
    pdf_ready: "PDF report ready!",
    download_pdf: "Download PDF",
    daily_report: "Daily Report",
    weekly_report: "Weekly Report",
    report_generated: "Report generated",

    // FAQ
    faq_title: "Frequently Asked Questions",
    faq_subtitle: "Answers to the most common questions about RistoMetrix",
    faq_stress_q: "How does the Stress Test work?",
    faq_stress_a: "The Stress Test analyzes your restaurant's financial sustainability. Enter your real data (average ticket, covers, staff costs, rent, etc.) and Sofia AI calculates the break-even, monthly and annual profit, and provides a verdict on your venue's viability.",
    faq_simulator_q: "How does the Scenario Simulator work?",
    faq_simulator_a: "The Simulator lets you do 'what-if' analysis. Start from Stress Test data and modify one or more parameters (e.g.: raise the average ticket, hire a staff member). Sofia calculates the financial impact and tells you if the change is beneficial.",
    faq_daily_q: "How do I use the Daily Tracker?",
    faq_daily_a: "Record your daily income, number of receipts and clients each day. The system automatically calculates the average ticket and monitors performance with a daily score, comparing it with the average and break-even.",
    faq_benchmark_q: "How does the Market Benchmark work?",
    faq_benchmark_a: "It compares your restaurant's KPIs (food cost, margin, average ticket, etc.) with Italian restaurant industry benchmarks for your cuisine type. You receive a positioning score from 0 to 100.",
    faq_menu_audit_q: "What is the Menu Audit?",
    faq_menu_audit_a: "The Menu Audit automatically analyzes each dish on your menu: checks food cost, margin, and identifies problematic items. Sofia AI generates a report with specific recommendations to optimize your menu.",
    faq_menu_eng_q: "What is Menu Engineering?",
    faq_menu_eng_a: "Menu Engineering classifies menu items into 4 categories (Star, Puzzle, Plowhorse, Dog) based on popularity and margin. You receive recommended actions for each dish: promote, reprice, remove from menu, etc.",
    faq_currency_q: "How do I change the currency?",
    faq_currency_a: "Go to Settings and select the desired currency. The symbol will update automatically across all app pages. 10 currencies are supported: EUR, USD, GBP, THB, CHF, JPY, AUD, CAD, AED, SGD.",
    faq_dark_q: "How do I enable Dark Mode?",
    faq_dark_a: "You can enable Dark Mode from the button in the sidebar (moon/sun icon) or from the Settings page in the Theme section.",
    faq_staff_q: "How do I manage staff?",
    faq_staff_a: "In the Staff section you can add employees with gross/net salary, weekly hours, department and role. You can also terminate employees with severance pay calculation. The Staff Optimizer calculates the optimal staffing for kitchen, dining room and bar.",
    faq_pdf_q: "How do I generate PDF reports?",
    faq_pdf_a: "On the Reports & Audit page, in the PDF Reports section, you can generate daily or weekly reports. The report includes a performance summary, charts and Sofia AI analysis.",

    // Expense Analysis & Alerts
    expense_analysis: "Expense Analysis",
    expense_analysis_subtitle: "Advanced cost analysis, thresholds and profitability by area",
    expense_alerts_tab: "Expense Alerts",
    area_analysis_tab: "Area Analysis",
    no_alerts: "No active alerts",
    no_alerts_desc: "All parameters are within thresholds. Great job!",
    alert_severity_high: "Critical",
    alert_severity_medium: "Warning",
    threshold: "Threshold",
    current_value: "Current value",
    total_revenue_label: "Total Revenue",
    total_expenses_label: "Total Expenses",
    total_staff_cost_label: "Staff Cost",
    net_margin_label: "Net Margin",
    department_label: "Department",
    staff_cost_label: "Staff Cost",
    estimated_revenue_label: "Estimated Revenue",
    profit_label: "Profit",
    cost_pct_label: "Cost/Revenue",
    area_status_ok: "OK",
    area_status_warning: "Warning",
    area_status_critical: "Critical",
    area_status_no_revenue: "No sales",
    no_area_data: "No area data available",
    no_area_data_desc: "Enter category sales in the Daily Tracker and add staff to analyze areas.",
    category_sales_title: "Sales by Category",
    category_sales_desc: "Record the number of dishes sold by category",
    dish_sales_title: "Sales by Dish (from Menu)",
    dish_sales_desc: "Quantities sold per individual dish",
    dishes_sold: "dishes sold",
    revenue_from_dishes: "Dish revenue",
    sold: "sold",
    no_menu_items_title: "No dishes in menu",
    no_menu_items_desc: "To track sales per dish, add your menu first. Dishes will appear here with price and food cost.",
    go_to_menu: "Go to Menu",
    qty_sold: "Qty sold",
    daily_detail: "Daily Detail",
    weekly_summary_title: "Weekly Summary",
    history_title: "Entry History",
    start_tracking: "Start Tracking",
    start_tracking_desc: "Start entering daily income to monitor performance",
    avg_ticket_label: "Avg ticket",
    spend_per_client: "Spend/client",
    of_average: "of average",
    clients_label: "clients",
    ticket_label: "ticket",
    below_breakeven: "Below break-even",
    avg_daily_label: "avg/day",
    days_recorded: "days",
    date_range_label: "Date Range",
    range_mode_desc: "Data will be entered for each day in the selected range",
    date_from: "Start Date",
    date_to: "End Date",
    days_label: "days",
    days_saved: "days saved",
    date_range_error: "Start date must be before end date",
    date_range_too_long: "Maximum range: 90 days",
    income_label: "Income",
    receipts_label: "Receipts",
    avg_ticket_col: "Avg Ticket",
    staff_members_label: "members",

    // Restaurant Detail
    months_of_data: "months of data",
    financial_data: "Financial Data",
    export_csv: "Export CSV",
    add_monthly_data: "Add monthly data",
    add_financial_data: "Add financial data",
    month_yyyy_mm: "Month (YYYY-MM)",
    rent: "Rent",
    utilities: "Utilities",
    other_costs: "Other Costs",
    revenue_profit_trend: "Revenue & Profit Trend",
    cost_breakdown: "Cost Breakdown (Last month)",
    month_label: "Month",
    reviews_by_platform: "Reviews by Platform",
    recent_reviews: "Recent Reviews",
    reviews_count: "reviews",

    // Team Page
    team_subtitle: "Manage sub-users and their permissions",
    add_member: "Add member",
    edit_member: "Edit Member",
    new_member: "New Team Member",
    member_subtitle: "Create a sub-user with specific permissions",
    enter_password: "Enter a password",
    member_updated: "Member updated!",
    member_added: "Member added to team!",
    member_deleted: "Member deleted",
    confirm_delete_member: "Delete this team member?",
    name_label: "Name",
    email_label: "Email",
    password_label: "Password",
    role_label: "Role",
    role_viewer: "View Only",
    role_viewer_desc: "View Only - Can only view",
    role_editor: "Editor",
    role_editor_desc: "Editor - Can edit menu, staff, expenses",
    role_admin: "Administrator",
    role_admin_desc: "Administrator - Full access",
    restaurant_access: "Restaurant Access",
    restaurant_access_desc: "Select which restaurants they can access (empty = all)",
    no_team_members: "No team members",
    no_team_members_desc: "Add sub-users to give your team access with custom permissions.",
    add_first_member: "Add first member",
    restaurants_count: "restaurants",

    // Alerts Page
    alerts_title: "Alerts & Notifications",
    alerts_subtitle: "Configure automatic alerts and view notifications",
    alert_settings: "Alert Settings",
    alert_settings_desc: "Configure thresholds for automatic alerts",
    food_cost_threshold: "Food Cost Threshold (%)",
    menu_avg_fc_threshold: "Menu Avg FC%",
    margin_threshold: "Margin Threshold (%)",
    rating_threshold: "Rating Threshold",
    break_even_alert: "Daily Break-Even Alert",
    break_even_alert_desc: "Notify when daily revenue is below break-even",
    inventory_discrepancy_threshold: "Inventory Discrepancy Threshold (%)",
    discrepancy_threshold_desc: "% difference between purchased and theoretical consumption per ingredient",
    alert_if_above: "Alert if above",
    alert_if_below: "Alert if below",
    in_app_notifications: "In-App Notifications",
    in_app_notifications_desc: "Show alerts in dashboard",
    email_notifications: "Email Notifications",
    email_notifications_desc: "Receive alerts via email",
    alerts_list: "Alerts",
    alerts_history: "Notification history",
    mark_all_read: "Mark all as read",
    value_label: "Value",
    threshold_label: "Threshold",
    no_alerts_history: "Alerts will appear here when your restaurant parameters exceed configured thresholds.",

    // CRM (second EN block)
    crm_title: "CRM & Outreach",
    crm_subtitle: "Sales pipeline, contacts and AI coach",
    tab_prospects: "Prospects",
    tab_search_city: "Search City",
    tab_import: "Import",
    tab_campaign: "Campaign",
    tab_ai_coach: "AI Coach",
    type_thai_fine_dining: "Thai Fine Dining",
    type_thai_local: "Thai Local / Street Food",
    check_now: "Check Now",
    checking: "Checking...",

    // Login Page
    login: "Login",
    register: "Register",
    welcome_back: "Welcome back",
    login_subtitle: "Log in to manage your restaurants",
    logging_in: "Logging in...",
    login_error: "Login error",
    create_account: "Create an account",
    register_subtitle: "Start monitoring your restaurant performance",
    full_name: "Full name",
    company_name: "Company name (optional)",
    account_type: "Account type",
    single_type: "Single",
    single_desc: "One restaurant",
    multi_type: "Multi-location",
    multi_desc: "Multiple restaurants",
    registering: "Registering...",
    register_error: "Registration error",
    hero_title: "Manage your restaurant performance",
    hero_revenue: "Revenue & cost analysis",
    hero_reviews: "Review monitoring",
    hero_multi: "Multi-location comparison",
    hero_ai: "AI suggestions",

    // Integrations Page
    configured: "Configured",
    not_configured: "Not configured",
    syncing: "Syncing...",
    sync: "Sync",
    import_csv: "Import CSV",
    import_from_csv: "Import from CSV",
    import_reviews: "Import reviews",
    import_manual_review: "Add manual review",
    import_review_title: "Import manual review",
    import_review_desc: "Enter review data",
    reviews_imported: "reviews imported",
    platform_label: "Platform",
    platform_origin: "Source platform",
    upload_csv: "Upload CSV file",
    paste_csv: "Or paste CSV content",
    csv_format: "CSV format: author, rating (1-5), date (YYYY-MM-DD), text",
    importing: "Importing...",
    import_btn: "Import",
    import_error: "Import error",
    import_csv_error: "CSV import error",
    author_label: "Author",
    text_label: "Text",
    email_alerts_title: "Email Notifications",
    email_alerts_desc: "Receive automatic alerts when metrics exceed thresholds",
    send_test_email: "Send test email",
    saving_settings: "Saving...",
    save_all_settings: "Save all settings",
    google_how_to: "How to connect Google Reviews:",
    tripadvisor_no_api: "TripAdvisor does not offer public APIs",
    thefork_no_api: "TheFork does not offer public APIs",

    // Restaurants Page
    add_restaurant: "Add restaurant",
    select_placeholder: "Select...",

    // Reviews Page
    select_restaurant: "Select restaurant",

    // Competitors Page
    competitor_data_desc: "Enter competitor data for comparison",
    strengths: "Strengths",
    strengths_placeholder: "What they do well...",
    weaknesses: "Weaknesses",
    weaknesses_placeholder: "Where they're weak...",
    overall_score: "Overall score",
    price_comparison: "Price Comparison by Category",
    your_price: "Your price",

    // Operations/Waste
    avg_margin_label: "Avg margin",
    avg_price_label: "Avg price",
    add_menu_items_matrix: "Add menu items to see the matrix",
    staff_optimization: "Staff Optimization",
    avg_hourly_cost: "Avg Hourly Cost",
    total_needed: "Total Needed",
    staff_cost_day: "Staff cost/day",
    cost_per_cover: "Cost per cover",

    // Viability Test
    enter_data: "Enter restaurant data",
    employees_label: "employees",
    avg_cost_label: "avg cost",
    covers_month: "covers/month",
    working_days: "working days",
    current_covers: "current covers",
    scenario_desc: "What happens if I change something? Enter only the values you want to modify",

    // Expenses
    all_months: "All months",

    // Auto Reports & Audit
    auto_reports: "Automatic Reports",
    auto_reports_desc: "Configure automatic PDF report generation",
    auto_reports_frequency: "Frequency",
    auto_reports_daily: "Daily",
    auto_reports_weekly: "Weekly",
    auto_reports_disabled: "Disabled",
    auto_reports_saved: "Auto report settings saved",
    auto_audit: "Automatic Menu Audit",
    auto_audit_desc: "Automatic monthly menu performance analysis",
    auto_audit_enabled: "Auto audit enabled",
    auto_audit_disabled: "Auto audit disabled",
    last_auto_report: "Last auto report",
    last_auto_audit: "Last auto audit",
    never: "Never",
    download_report: "Download Report",
    auto_reports_list: "Generated Reports",
    no_auto_reports: "No auto reports generated",

    // Food Cost Page
    food_cost_title: "Food Cost Control",
    suppliers_tab: "Suppliers",
    ingredients_tab: "Ingredients",
    invoices_tab: "Invoices",
    monthly_fc_tab: "Monthly FC",
    monthly_area_tab: "FC by Area",
    credit_notes_tab: "Credit Notes",
    scan_invoice: "Scan Invoice",
    invoice_analyzed: "Invoice analyzed successfully",
    invoice_saved: "Invoice saved!",
    add_supplier: "Add Supplier",
    supplier_name: "Supplier Name",
    contact: "Contact",
    add_ingredient: "Add Ingredient",
    ingredient_name: "Ingredient Name",
    unit: "Unit",
    packing: "Packing",
    no_suppliers: "No suppliers",
    no_ingredients: "No ingredients",
    no_invoices: "No invoices",
    total_purchases: "Total Purchases",
    avg_food_cost_pct: "Avg FC%",
    real_vs_theoretical: "Real vs Theoretical",
    theoretical: "Theoretical",
    real: "Real",
    area: "Area",

    // Cash Flow Simulator
    cash_flow_title: "Cash Flow Simulator",
    cash_flow_page_title: "Cash Flow",
    revenue_label_full: "Revenue",
    staff_label_full: "Staff",
    rent_label: "Rent",
    food_cost_label: "Food Cost",
    marketing_label: "Marketing",
    utilities_label: "Utilities",
    other_label: "Other",
    ebitda_label: "EBITDA",
    margin_label: "Margin",
    base_scenario_label: "Base Scenario",
    new_scenario_label: "New Scenario",
    impact_label: "Impact",
    monthly_label: "Monthly",
    annual_label: "Annual",
    add_scenario: "Add Scenario",
    quick_scenarios: "Quick Scenarios",
    custom_scenario: "Custom Scenario",
    revenue_change: "Revenue Change",
    add_staff: "Add Staff",
    remove_staff: "Remove Staff",
    cost_per_month: "Cost/month",
    change_rent: "Change Rent",
    delta: "Delta",
    food_cost_change: "Food Cost Change",
    amount: "Amount",
    run_simulation_btn: "Simulate",
    simulating: "Simulating...",
    revenue_vs_costs: "Revenue vs Daily Cost Line",
    cost_breakdown_label: "Cost Breakdown",

    // Profit & Loss
    profit_loss_title: "Profit & Loss",
    gross_revenue_label: "Gross Revenue",
    net_revenue: "Net Revenue",
    food_cost_pl: "Raw Materials",
    gross_margin: "Gross Margin",
    staff_cost_pl: "Staff Cost",
    operating_margin: "Operating Margin",
    rent_pl: "Rent",
    utilities_pl: "Utilities",
    marketing_pl: "Marketing",
    other_expenses_pl: "Other Expenses",
    iva_label: "VAT",
    vat_label: "VAT",
    vat_settlement: "VAT Settlement",
    sales_vat: "Sales VAT (debit)",
    purchase_vat: "Purchase VAT (credit)",
    delta_vat: "VAT PAYABLE",
    no_invoices_vat: "No invoices recorded for this month. Scan invoices to calculate actual purchase VAT.",
    net_amount: "Net Amount",
    quarterly_view: "Quarterly",
    cumulative_view: "Cumulative",
    kpi_benchmarks: "KPI vs Benchmark",
    benchmark: "Benchmark",
    your_value_label: "Your value",

    // Staff Analysis
    staff_analysis_title: "Staff Analysis",
    revenue_per_employee: "Revenue/Employee",
    cost_revenue_ratio: "Cost/Revenue",
    revenue_30d: "30d revenue",
    pct_revenue: "% Revenue",

    // Restaurant Detail
    use_existing_costs: "Use existing costs (Staff + Expenses)",
    gross_revenue_short: "Gross Revenue",

    // Comparison
    total_revenue_compare: "Total Revenue",
    restaurants_label: "Restaurants",
    health_score_label: "Restaurant Health Scores",

    // Dashboard extra
    food_cost_health: "Food Cost",
    labor_cost_health: "Staff",
    margin_health: "Margin",

    // Menu Engineering
    menu_eng_title: "Menu Engineering",
    stars: "Stars",
    puzzles: "Puzzles",
    plowhorses: "Plowhorses",
    dogs: "Dogs",
    popularity: "Popularity",
    profitability: "Profitability",
    high: "High",
    low: "Low",
    keep_promote: "Keep and promote",
    increase_price: "Increase price",
    reduce_cost: "Reduce cost",
    consider_removing: "Consider removing",

    // Viability Test
    viability_title: "Stress Test & Simulator",
    kitchen: "Kitchen",
    pizzeria: "Pizzeria",
    bar: "Bar",

    // Billing
    annual_billing: "Annual billing",
    monthly_billing: "Monthly billing",
    payment_success: "Payment completed",
    payment_cancel: "Payment cancelled",
    plan_active: "Active plan",
    upgrade: "Upgrade",
    current_plan: "Current plan",

    // Login extra
    welcome_back_title: "Welcome back",
    register_title: "Create Account",

    // SuperAdmin
    users_label: "Users",
    total_users: "Total Users",
    active_users: "Active Users",
    total_restaurants: "Total Restaurants",
  },
  th: {
    // Navigation
    dashboard: "แดชบอร์ด",
    restaurants: "ร้านอาหาร",
    comparison: "เปรียบเทียบสาขา",
    reviews: "รีวิว",
    sofia_ai: "Sofia AI",
    settings: "ตั้งค่า",
    menu: "เมนู",
    staff: "บุคลากร",
    expenses: "ค่าใช้จ่าย",
    alerts: "การแจ้งเตือน",
    logout: "ออกจากระบบ",
    integrations: "การเชื่อมต่อ",
    competitors: "คู่แข่ง",
    team: "ทีม",
    faq: "คำถามที่พบบ่อย",
    reports: "รายงาน",

    // Dashboard
    overview: "ภาพรวม",
    total_revenue: "รายรับรวม",
    total_reviews: "รีวิวทั้งหมด",
    avg_rating: "คะแนนเฉลี่ย",
    profit_margin: "อัตรากำไร",
    food_cost: "ต้นทุนอาหาร",
    labor_cost: "ต้นทุนบุคลากร",
    revenue_by_restaurant: "รายรับตามร้าน",
    profit_margin_chart: "อัตรากำไร (%)",
    your_restaurants: "ร้านอาหารของคุณ",
    view_all: "ดูทั้งหมด",
    revenue: "รายรับ",
    vs_last_month: "เทียบเดือนก่อน",
    health_score: "คะแนนสุขภาพร้านอาหาร",

    // Common
    save: "บันทึก",
    cancel: "ยกเลิก",
    delete: "ลบ",
    edit: "แก้ไข",
    add: "เพิ่ม",
    search: "ค้นหา",
    filter: "กรอง",
    export: "ส่งออก",
    import_label: "นำเข้า",
    loading: "กำลังโหลด...",
    no_data: "ไม่มีข้อมูล",
    back: "กลับ",
    confirm: "ยืนยัน",
    close: "ปิด",
    name: "ชื่อ",
    price: "ราคา",
    cost: "ต้นทุน",
    margin: "กำไร",
    category: "หมวดหมู่",
    description: "คำอธิบาย",
    available: "พร้อมใช้งาน",
    not_available: "ไม่พร้อมใช้งาน",
    total: "รวม",
    average: "เฉลี่ย",
    select: "เลือก...",
    actions: "การดำเนินการ",
    error: "ข้อผิดพลาด",
    error_loading: "เกิดข้อผิดพลาดในการโหลดข้อมูล",
    error_saving: "เกิดข้อผิดพลาดในการบันทึก",
    error_deleting: "เกิดข้อผิดพลาดในการลบ",
    members: "สมาชิก",
    excellent: "ยอดเยี่ยม",
    good: "ดี",
    fair: "พอใช้",
    poor: "แย่",
    download: "ดาวน์โหลด",
    generate: "สร้าง",
    daily: "รายวัน",
    weekly: "รายสัปดาห์",

    // Menu
    menu_management: "จัดการเมนู",
    menu_categories: "หมวดหมู่เมนู",
    manage_categories: "จัดการหมวดหมู่",
    add_remove_categories: "เพิ่มหรือลบหมวดหมู่",
    add_dish: "เพิ่มเมนู",
    edit_dish: "แก้ไขเมนู",
    new_dish: "เมนูใหม่",
    dish_name: "ชื่อเมนู",
    enter_dish_details: "กรอกรายละเอียดเมนู",
    selling_price: "ราคาขาย",
    dish_cost: "ต้นทุนเมนู",
    avg_price: "ราคาเฉลี่ย",
    avg_margin: "กำไรเฉลี่ย",
    total_dishes: "เมนูทั้งหมด",
    empty_menu: "เมนูว่าง",
    empty_menu_desc: "เพิ่มเมนูเพื่อติดตามกำไรและรับคำแนะนำราคาจาก AI",
    add_first_dish: "เพิ่มเมนูแรก",
    new_category: "ชื่อหมวดหมู่ใหม่...",
    select_category: "เลือกหมวดหมู่...",
    dish_updated: "อัปเดตเมนูแล้ว!",
    dish_added: "เพิ่มเมนูแล้ว!",
    dish_deleted: "ลบเมนูแล้ว",
    confirm_delete_dish: "คุณแน่ใจหรือไม่ว่าต้องการลบเมนูนี้?",
    category_added: "เพิ่มหมวดหมู่แล้ว!",
    category_deleted: "ลบหมวดหมู่แล้ว",
    confirm_delete_category: "ลบหมวดหมู่นี้?",

    // Staff
    staff_management: "จัดการบุคลากร",
    staff_categories: "หมวดหมู่บุคลากร",
    manage_depts_roles: "จัดการแผนกและตำแหน่ง",
    manage_staff_categories: "จัดการหมวดหมู่",
    add_member: "เพิ่มสมาชิก",
    new_member: "สมาชิกใหม่",
    edit_member: "แก้ไขสมาชิก",
    enter_staff_details: "กรอกข้อมูลพนักงาน",
    first_name: "ชื่อ",
    last_name: "นามสกุล",
    role: "ตำแหน่ง",
    department: "แผนก",
    contract_type: "ประเภทสัญญา",
    gross_salary: "เงินเดือน (รวม)",
    net_salary: "เงินเดือน (สุทธิ)",
    gross_monthly: "รวม/เดือน",
    net_monthly: "สุทธิ/เดือน",
    gross: "รวม",
    net: "สุทธิ",
    hours_week: "ชั่วโมง/สัปดาห์",
    hire_date: "วันที่เริ่มงาน",
    active: "ใช้งาน",
    departments: "แผนก",
    roles: "ตำแหน่ง",
    total_staff: "บุคลากรทั้งหมด",
    total_payroll: "ต้นทุนบุคลากรรวม",
    active_employees: "พนักงานปัจจุบัน",
    terminated_employees: "เลิกจ้าง",
    no_employees: "ไม่มีพนักงาน",
    no_employees_desc: "เพิ่มพนักงานเพื่อติดตามต้นทุนบุคลากร",
    add_first_member: "เพิ่มพนักงานคนแรก",
    no_terminated: "ไม่มีพนักงานที่ถูกเลิกจ้าง",
    category_name: "ชื่อหมวดหมู่...",
    staff_updated: "อัปเดตพนักงานแล้ว!",
    staff_added: "เพิ่มพนักงานแล้ว!",
    staff_deleted: "ลบพนักงานแล้ว",
    confirm_delete_staff: "คุณแน่ใจหรือไม่ว่าต้องการลบพนักงานนี้?",
    avg_hourly_cost: "ต้นทุนรายชั่วโมงเฉลี่ย",
    hourly_cost_label: "ต้นทุน/ชม.",
    terminate: "เลิกจ้าง",
    terminate_employee: "เลิกจ้างพนักงาน",
    termination_date: "วันที่เลิกจ้าง",
    termination_date_required: "ต้องระบุวันที่เลิกจ้าง",
    severance_pay: "เงินชดเชย",
    severance_description: "จำนวนเงินชดเชยที่จ่ายให้พนักงาน",
    confirm_termination: "ยืนยันการเลิกจ้าง",
    terminated: "เลิกจ้างแล้ว",
    terminated_on: "เลิกจ้างเมื่อ",
    terminated_count: "เลิกจ้าง",
    staff_terminated: "เลิกจ้างพนักงานแล้ว",

    // Expenses
    expense_management: "จัดการค่าใช้จ่าย",
    add_expense: "เพิ่มค่าใช้จ่าย",
    expense_categories: "หมวดหมู่ค่าใช้จ่าย",
    fixed_expenses: "ค่าใช้จ่ายคงที่",
    variable_expenses: "ค่าใช้จ่ายผันแปร",
    total_expenses: "ค่าใช้จ่ายรวม",
    monthly_filter: "กรองตามเดือน",
    expense_breakdown: "รายละเอียดค่าใช้จ่าย",

    // Restaurants
    add_restaurant: "เพิ่มร้านอาหาร",
    single_account: "บัญชีเดียว - 1 ร้าน",
    multi_account: "จัดการร้านอาหารและสาขาของคุณ",
    restaurant_details: "รายละเอียดร้านอาหาร",
    financial_metrics: "ตัวชี้วัดทางการเงิน",

    // Integrations
    integrations_title: "การเชื่อมต่อ",
    configure_connections: "กำหนดค่าการเชื่อมต่อและนำเข้าข้อมูลของคุณ",
    csv_import: "นำเข้าจาก CSV",
    manual_import: "เพิ่มรีวิวด้วยตนเอง",
    configured: "กำหนดค่าแล้ว",
    not_configured: "ยังไม่ได้กำหนดค่า",
    imported_reviews: "รีวิวที่นำเข้า",
    save_all: "บันทึกการตั้งค่าทั้งหมด",

    // Competitors
    competitor_analysis: "วิเคราะห์คู่แข่ง",
    compare_desc: "เปรียบเทียบราคา คะแนน และตำแหน่ง",
    add_competitor: "เพิ่มคู่แข่ง",
    no_competitors: "ไม่มีคู่แข่ง",
    positioning: "ตำแหน่ง",
    rating_comparison: "เปรียบเทียบคะแนน",
    price_comparison: "เปรียบเทียบราคา",
    overview_tab: "ภาพรวม",
    ratings_tab: "คะแนน",
    prices_tab: "ราคา",
    detail_tab: "รายละเอียด",
    strengths: "จุดแข็ง",
    weaknesses: "จุดอ่อน",
    price_range: "ช่วงราคา",
    website: "เว็บไซต์",

    // AI
    sofia_title: "Sofia",
    sofia_subtitle: "ผู้ช่วยอัจฉริยะเพื่อเพิ่มประสิทธิภาพร้านอาหารของคุณ",
    analyze_reviews: "วิเคราะห์รีวิว",
    optimize_pricing: "ปรับราคาให้เหมาะสม",
    analyze_performance: "วิเคราะห์ประสิทธิภาพ",
    analyze_menu: "ปรับเมนูให้เหมาะสม",
    start_analysis: "เริ่มวิเคราะห์",
    analyzing: "Sofia กำลังวิเคราะห์...",
    analysis_complete: "วิเคราะห์เสร็จสิ้น",
    recommendations: "คำแนะนำ",
    sofia_analysis: "การวิเคราะห์ของ Sofia",
    sofia_opinion: "ความเห็นของ Sofia",
    sofia_report: "รายงานของ Sofia",

    // Auth
    login: "เข้าสู่ระบบ",
    register: "ลงทะเบียน",
    email: "อีเมล",
    password: "รหัสผ่าน",
    your_name: "ชื่อของคุณ",
    company_name: "ชื่อบริษัท",
    account_type: "ประเภทบัญชี",
    single_type: "เดี่ยว",
    single_desc: "ร้านอาหารเดียว",
    multi_type: "หลายสาขา",
    multi_desc: "หลายร้านอาหาร",

    // Extra
    refresh: "รีเฟรช",
    load_demo: "โหลดข้อมูลตัวอย่าง",
    demo_loaded: "โหลดข้อมูลตัวอย่างสำเร็จ!",
    no_restaurants_yet: "ยังไม่มีร้านอาหาร",
    no_restaurants_desc: "เริ่มต้นโดยเพิ่มร้านอาหารแรกหรือโหลดข้อมูลตัวอย่างเพื่อสำรวจฟีเจอร์",

    // Settings
    settings_title: "ตั้งค่า",
    general_settings: "ตั้งค่าทั่วไป",
    language: "ภาษา",
    currency: "สกุลเงิน",
    profile: "โปรไฟล์",
    profile_info: "ข้อมูลบัญชีของคุณ",
    manage_account: "จัดการบัญชี",
    member_since: "สมาชิกตั้งแต่",
    company: "บริษัท",
    select_currency_desc: "เลือกสกุลเงินสำหรับจำนวนเงินทั้งหมด",
    theme: "ธีม",
    theme_desc: "เลือกระหว่างโหมดสว่างและมืด",
    danger_zone: "โซนอันตราย",
    irreversible_actions: "การดำเนินการที่ไม่สามารถย้อนกลับได้",
    logout_account: "ออกจากระบบ",
    logout_desc: "คุณจะถูกตัดการเชื่อมต่อจากเซสชันนี้",
    currency_changed: "เปลี่ยนสกุลเงินเป็น",

    // Alerts
    alert_settings: "ตั้งค่าการแจ้งเตือน",
    food_cost_threshold: "เกณฑ์ต้นทุนอาหาร (%)",
    menu_avg_fc_threshold: "FC% เมนูเฉลี่ย",
    margin_threshold: "เกณฑ์กำไร (%)",
    rating_threshold: "เกณฑ์คะแนน",
    break_even_alert: "แจ้งเตือนจุดคุ้มทุนรายวัน",
    break_even_alert_desc: "แจ้งเตือนเมื่อรายได้ต่ำกว่าจุดคุ้มทุน",
    inventory_discrepancy_threshold: "เกณฑ์ความคลาดเคลื่อนสินค้าคงคลัง (%)",
    discrepancy_threshold_desc: "ความแตกต่าง % ระหว่างที่ซื้อกับการบริโภคตามทฤษฎีต่อวัตถุดิบ",
    email_notifications: "การแจ้งเตือนอีเมล",
    in_app_notifications: "การแจ้งเตือนในแอป",

    // CRM & Prospects
    crm_title: "CRM & การติดต่อ",
    crm_subtitle: "ขั้นตอนการขาย, ผู้ติดต่อ และ AI โค้ช",
    tab_prospects: "ผู้สนใจ",
    tab_search_city: "ค้นหาเมือง",
    tab_import: "นำเข้า",
    tab_campaign: "แคมเปญ",
    tab_ai_coach: "AI โค้ช",
    total_label: "ทั้งหมด",
    with_email_label: "มีอีเมล",
    contacted_label: "ติดต่อแล้ว",
    priority_a: "ลำดับ A",
    priority_b: "ลำดับ B",
    search_placeholder: "ค้นหาชื่อ, อีเมล, เมือง...",
    all_priorities: "ทุกลำดับ",
    all_types: "ทุกประเภท",
    selected_count: "เลือกแล้ว",
    delete_label: "ลบ",
    send_campaign_label: "ส่งแคมเปญ",
    contacts_label: "การติดต่อ",
    actions_label: "การดำเนินการ",
    add_email: "+ เพิ่มอีเมล",
    no_prospects: "ไม่พบผู้สนใจ ใช้ 'ค้นหาเมือง' หรือ 'นำเข้า' เพื่อเพิ่ม",
    status_da_contattare: "รอติดต่อ",
    status_contattato: "ติดต่อแล้ว",
    status_risposta_ricevuta: "ได้รับตอบกลับ",
    status_call_proposta: "เสนอโทร",
    status_demo_fissata: "นัดเดโม",
    status_demo_fatta: "เดโมเสร็จ",
    status_in_valutazione: "กำลังประเมิน",
    status_chiuso: "ปิดการขาย",
    status_perso: "สูญเสีย",
    status_follow_up_futuro: "ติดตามในอนาคต",
    type_hotel: "โรงแรม",
    type_hotel_luxury: "โรงแรมหรู",
    type_ristorante_indipendente: "ร้านอาหารอิสระ",
    type_italian_independent: "ร้านอิตาเลียนอิสระ",
    type_catena: "เชนร้านอาหาร",
    type_franchising_master: "แฟรนไชส์ / มาสเตอร์",
    type_resort: "รีสอร์ท",
    type_michelin: "มิชลิน / ไฟน์ไดนิ่ง",
    type_thai_fine_dining: "ไฟน์ไดนิ่งไทย",
    type_thai_local: "ร้านอาหารไทยท้องถิ่น / สตรีทฟู้ด",
    type_other: "อื่นๆ",
    franchise_nav: "แฟรนไชส์",
    franchise_management_title: "การจัดการแฟรนไชส์",
    franchise_management_desc: "สร้างและจัดการกลุ่มแฟรนไชส์ ผู้ใช้มาสเตอร์ และแผนสมาชิกที่กำหนดเอง",
    franchise_add_group: "กลุ่มใหม่",
    franchise_new: "กลุ่มแฟรนไชส์ใหม่",
    franchise_edit: "แก้ไขกลุ่ม",
    franchise_name: "ชื่อกลุ่ม",
    franchise_brand: "ชื่อแบรนด์",
    franchise_contact_person: "ผู้ติดต่อ",
    franchise_contact_email: "อีเมลผู้ติดต่อ",
    franchise_region: "ภูมิภาค",
    franchise_payment_mode: "โหมดการชำระเงิน",
    franchise_master_pays: "มาสเตอร์จ่าย",
    franchise_individual_pays: "สาขาจ่ายแยก",
    franchise_custom_plan: "แผนที่กำหนดเอง",
    franchise_price_monthly: "ราคาต่อเดือน (€)",
    franchise_price_label: "ป้ายราคา",
    franchise_max_outlets: "สาขาสูงสุด",
    franchise_plan_notes: "หมายเหตุข้อตกลง",
    franchise_plan_notes_hint: "เงื่อนไขพิเศษ ส่วนลด ฯลฯ",
    franchise_create: "สร้างกลุ่ม",
    franchise_update: "อัปเดต",
    franchise_created: "สร้างกลุ่มแล้ว!",
    franchise_updated: "อัปเดตกลุ่มแล้ว!",
    franchise_deleted: "ลบกลุ่มแล้ว",
    franchise_confirm_delete: "คุณแน่ใจหรือไม่ว่าต้องการลบกลุ่มนี้?",
    franchise_no_groups: "ยังไม่มีกลุ่มแฟรนไชส์ สร้างเลย!",
    franchise_master_user: "ผู้ใช้มาสเตอร์",
    franchise_no_master: "ไม่มีมาสเตอร์",
    franchise_create_master: "สร้างผู้ใช้มาสเตอร์",
    franchise_master_name: "ชื่อมาสเตอร์",
    franchise_company: "บริษัท",
    franchise_master_created: "สร้างผู้ใช้มาสเตอร์แล้ว!",
    franchise_view_dashboard: "ดูแดชบอร์ด",
    franchise_outlets: "สาขา",
    franchise_no_outlets: "ไม่มีสาขาที่เชื่อมต่อ",
    franchise_add_outlet: "เพิ่มสาขา...",
    franchise_restaurant_added: "เพิ่มสาขาแล้ว!",
    master_dashboard_nav: "แดชบอร์ดมาสเตอร์",
    master_dashboard_title: "แดชบอร์ดมาสเตอร์แฟรนไชส์",
    master_no_data: "ไม่มีข้อมูล",
    master_total_outlets: "สาขา",
    master_total_revenue: "รายได้รวม",
    master_avg_food_cost: "ต้นทุนอาหารเฉลี่ย",
    master_total_alerts: "การแจ้งเตือนที่ใช้งาน",
    master_outlets_performance: "ผลงานสาขา",
    master_outlet_name: "สาขา",
    master_revenue: "รายได้",
    master_food_cost: "ต้นทุนอาหาร",
    master_margin: "มาร์จิ้น",
    master_rating: "เรทติ้ง",
    master_alerts_col: "แจ้งเตือน",
    master_actions: "การดำเนินการ",
    master_send_message_to: "ส่งข้อความถึง",
    master_message_placeholder: "เขียนข้อความถึงสาขานี้...",
    master_send: "ส่ง",
    master_message_sent: "ส่งข้อความแล้ว!",
    master_message_history: "ประวัติข้อความ",
    master_alert_message_prefix: "ตรวจพบการแจ้งเตือนสำหรับ",
    master_alert_message_suffix: "กรุณาตรวจสอบและแก้ไขทันที",
    master_threshold: "เกณฑ์",
    master_no_outlets: "ไม่มีสาขาที่เชื่อมต่อกับกลุ่มของคุณ",
    master_tab_overview: "ภาพรวม",
    master_tab_report: "รายงานรวม",
    master_report_title: "รายงานรวมแฟรนไชส์",
    master_report_trend: "แนวโน้ม",
    master_report_labor: "ต้นทุนบุคลากร",
    master_report_msgs: "ข้อความ",
    master_menu_analysis: "วิเคราะห์เมนู",
    master_menu_total: "ทั้งหมด",
    master_menu_item: "เมนู",
    master_menu_price: "ราคา",
    master_menu_margin: "มาร์จิ้น",
    master_menu_sales: "ยอดขาย/เดือน",
    master_menu_class: "คลาส",
    master_menu_no_items: "ไม่มีเมนู",
    master_menu_send_suggestion: "ส่งคำแนะนำการปรับปรุงเมนู",
    master_menu_suggestion_hint: "เช่น: เมนู Dog ควรถูกลบหรือปรับราคา...",
    master_suggestion_sent: "ส่งคำแนะนำไปยังสาขาแล้ว!",
    pipeline_status: "สถานะขั้นตอน",
    contact_person: "ผู้ติดต่อหลัก",
    contact_role_label: "ตำแหน่ง",
    business_type: "ประเภทธุรกิจ",
    priority_label: "ลำดับความสำคัญ",
    notes_strategic: "บันทึก / เหตุผลเชิงกลยุทธ์",
    followup_1: "ติดตาม 1",
    followup_2: "ติดตาม 2",
    register_contact: "บันทึกการติดต่อ",
    contact_outcome: "ผลลัพธ์",
    contact_notes: "บันทึกเพิ่มเติม...",
    status_unchanged: "สถานะไม่เปลี่ยน",
    register_btn: "บันทึก",
    contact_history: "ประวัติการติดต่อ",
    no_contacts: "ไม่มีการติดต่อ",
    generate_with_ai: "สร้างอีเมลด้วย AI โค้ช",
    channel_email: "อีเมล",
    channel_telefono: "โทรศัพท์",
    channel_whatsapp: "WhatsApp",
    channel_linkedin: "LinkedIn",
    channel_di_persona: "พบตัว",
    ai_coach_title: "AI Email โค้ช",
    ai_stage_label: "ขั้นตอนการขาย",
    ai_stage_primo: "1. ติดต่อครั้งแรก",
    ai_stage_primo_desc: "ได้รับการตอบกลับ",
    ai_stage_follow_up: "2. ติดตาม",
    ai_stage_follow_up_desc: "เสนอโทรสั้นๆ",
    ai_stage_dopo_risposta: "3. หลังตอบกลับ",
    ai_stage_dopo_risposta_desc: "นัดเดโม",
    ai_stage_post_demo: "4. หลังเดโม",
    ai_stage_post_demo_desc: "ปิดการขาย",
    ai_stage_ultimo: "5. ครั้งสุดท้าย",
    ai_stage_ultimo_desc: "ปิดด้วยความเคารพ",
    ai_lang_label: "ภาษา:",
    ai_second_lang: "+ ภาษาที่สอง:",
    ai_none: "ไม่มี",
    ai_generate: "สร้าง",
    ai_generating: "Sofia กำลังเขียน...",
    ai_subject_label: "หัวข้อ:",
    ai_body_label: "เนื้อหา:",
    ai_translation: "คำแปล:",
    ai_use_campaign: "ใช้สำหรับแคมเปญ",
    ai_copy: "คัดลอก",
    ai_sofia_tip: "คำแนะนำจาก Sofia",
    ai_no_prospect: "คลิกไอคอน AI ในรายชื่อผู้สนใจเพื่อสร้างอีเมลส่วนตัว",
    ai_go_list: "ไปที่รายการ",
    sofia_analyze_btn: "วิเคราะห์ผู้สนใจ",
    sofia_analyzing: "Sofia กำลังวิเคราะห์...",
    sofia_analysis_title: "การวิเคราะห์ของ Sofia สำหรับผู้สนใจนี้",
    sofia_analysis_summary: "สรุป",
    sofia_email_suggestions: "คำแนะนำสำหรับอีเมล",
    sofia_tone_recommendation: "โทนที่แนะนำ",
    sofia_key_pain_points: "ปัญหาหลัก",
    sofia_custom_hook: "Hook ที่กำหนดเอง",
    sofia_analysis_hint: "ก่อนสร้างอีเมล ให้ Sofia วิเคราะห์ผู้สนใจนี้เพื่อปรับแต่งข้อความให้ดีที่สุด",
    sofia_ai_feature_desc: "Sofia AI ในตัว: ติดตาม KPI, แจ้งเตือนอัตโนมัติ, สเตรสเทสต์, วิศวกรรมเมนู",
    sofia_save_analysis: "บันทึกการวิเคราะห์ไปยังผู้สนใจ",
    sofia_analysis_saved: "บันทึกการวิเคราะห์แล้ว!",
    sofia_saved_analysis_label: "การวิเคราะห์ที่บันทึกของ Sofia",
    sofia_saved_on: "บันทึกเมื่อ",
    sofia_selected: "เลือกแล้ว",
    sofia_select_hint: "เลือกคำแนะนำที่จะรวมในอีเมลที่สร้างโดย AI โค้ช",
    sofia_insert_in_email: "แทรกในอีเมล",
    sofia_inserted_in_email: "แทรกคำแนะนำในอีเมลแล้ว!",
    sofia_select_at_least_one: "เลือกอย่างน้อยหนึ่งคำแนะนำ",
    sofia_email_preview: "ในอีเมลจะพูดว่า",
    check_now: "ตรวจสอบตอนนี้",
    checking: "กำลังตรวจสอบ...",

    // Franchise Detection (Search)
    franchise_detected_title: "ตรวจพบแฟรนไชส์",
    franchise_brands_found: "แบรนด์ที่มีหลายสาขา",
    franchise_detected_desc: "Sofia ตรวจพบแบรนด์ที่มีหลายสาขาในพื้นที่นี้ ผู้สนใจเหล่านี้ถูกติดป้ายลำดับ F (แฟรนไชส์) — ติดต่อมาสเตอร์/โฮลดิ้ง!",
    franchise_locations_in_area: "สาขาในพื้นที่",
    total_reviews_short: "รีวิวทั้งหมด",
    franchise_master_target: "เป้าหมาย: มาสเตอร์",
    franchise_results_label: "ผลลัพธ์",
    franchise_select_all: "เลือกทั้งหมด",
    franchise_save_prospects: "บันทึกผู้สนใจ",
    franchise_label: "แฟรนไชส์",
    franchise_locations_detected: "สาขาที่ตรวจพบ",
    priority_f: "ลำดับ F (แฟรนไชส์)",

    // Platform Benchmark
    platform_benchmark_title: "เปรียบเทียบแพลตฟอร์ม",
    platform_benchmark_subtitle: "เปรียบเทียบกับร้านอาหารทั้งหมดในแพลตฟอร์ม",
    platform_benchmark_btn: "อันดับทั่วโลก",
    platform_your_score: "คะแนนของคุณ",
    platform_score_desc: "ตำแหน่งโดยรวมเมื่อเทียบกับร้านอาหารทั้งหมดในแพลตฟอร์ม",
    platform_total_restaurants: "ร้านอาหารทั้งหมด",
    platform_seg_global: "ทั้งหมด",
    platform_seg_city: "ตามเมือง",
    platform_seg_cuisine: "ตามประเภท",
    platform_your_value: "ของคุณ",
    platform_avg: "เฉลี่ย",
    platform_interpretation_title: "วิธีอ่านเกณฑ์มาตรฐาน",
    platform_interpretation_desc: "KPI แต่ละตัวแสดงตำแหน่งของคุณเมื่อเทียบกับค่าเฉลี่ยของแพลตฟอร์ม จุดสีระบุว่าคุณอยู่ในช่วง P25-P75 ยิ่งจุดเขียวมาก ผลงานยิ่งดี",
    platform_tier_excellent: "ดีเยี่ยม",
    platform_tier_average: "ปานกลาง",
    platform_tier_improve: "ต้องปรับปรุง",
    kpi_food_cost_pct: "ต้นทุนอาหาร %",
    kpi_food_cost_pct_desc: "ต้นทุนวัตถุดิบต่อรายได้",
    kpi_labor_cost_pct: "ต้นทุนบุคลากร %",
    kpi_labor_cost_pct_desc: "ต้นทุนแรงงานต่อรายได้",
    kpi_profit_margin: "อัตรากำไร %",
    kpi_profit_margin_desc: "เปอร์เซ็นต์กำไรสุทธิ",
    kpi_revenue: "รายได้เฉลี่ยต่อเดือน",
    kpi_revenue_desc: "รายได้เฉลี่ยรายเดือน",
    kpi_rent_pct: "ค่าเช่า %",
    kpi_rent_pct_desc: "ค่าเช่าต่อรายได้",
    refresh: "รีเฟรช",
    platform_lower_better: "(ยิ่งต่ำยิ่งดี)",
    platform_higher_better: "(ยิ่งสูงยิ่งดี)",
    source: "แหล่งที่มา",
    rating: "คะแนน",
    date: "วันที่",
    text: "ข้อความ",
    author: "ผู้เขียน",

    // Stress Test / Viability
    stress_test_title: "สเตรสเทสต์ & ตัวจำลอง",
    stress_test_subtitle: "Decision Intelligence เพื่อความยั่งยืนของร้านอาหารของคุณ",
    stress_test_tab: "สเตรสเทสต์",
    simulator_tab: "ตัวจำลอง",
    run_analysis: "วิเคราะห์",
    sofia_analyzes_desc: "Sofia วิเคราะห์ว่าร้านของคุณยั่งยืนหรือไม่จากตัวเลขจริง",
    use_existing_staff: "ใช้ข้อมูลบุคลากรที่มีอยู่",
    avg_ticket: "บิลเฉลี่ย",
    covers_per_day: "ที่นั่ง / วัน",
    working_days: "วันทำงาน / เดือน",
    food_cost_pct: "ต้นทุนอาหาร %",
    staff_count: "จำนวนบุคลากร",
    avg_staff_cost: "ต้นทุนเฉลี่ย/เดือน",
    monthly_rent: "ค่าเช่ารายเดือน",
    utilities_month: "สาธารณูปโภค / เดือน",
    marketing_month: "การตลาด / เดือน",
    other_expenses: "ค่าใช้จ่ายอื่น / เดือน",
    loan_payments: "ผ่อนชำระ / เดือน",
    break_even: "จุดคุ้มทุน",
    current_covers: "ที่นั่งปัจจุบัน",
    monthly_revenue: "รายรับ/เดือน",
    monthly_profit: "กำไร/เดือน",
    annual_revenue: "ปี",
    annual_profit: "ปี",
    total_costs: "ต้นทุนรวม",
    profit: "กำไร",
    scenario_desc_label: "อธิบายสถานการณ์",
    scenario_placeholder: "เช่น: เพิ่มบิลเฉลี่ยเป็น 30 และจ้างพนักงานเพิ่ม...",
    new_avg_ticket: "บิลเฉลี่ยใหม่",
    new_covers: "ที่นั่งใหม่/วัน",
    new_staff_count: "จำนวนบุคลากรใหม่",
    new_staff_cost: "ต้นทุนบุคลากรใหม่/เดือน",
    new_food_cost: "ต้นทุนอาหารใหม่ %",
    new_rent: "ค่าเช่าใหม่",
    run_simulation: "จำลองสถานการณ์",
    base_data: "ข้อมูลฐานปัจจุบัน:",
    run_stress_first: "วิเคราะห์สเตรสเทสต์ก่อน",
    what_if_desc: "จะเกิดอะไรขึ้นถ้าเปลี่ยนบางอย่าง? กรอกเฉพาะค่าที่ต้องการเปลี่ยน",
    base_scenario: "สถานการณ์ฐาน",
    new_scenario: "สถานการณ์ใหม่",
    impact: "ผลกระทบ",
    monthly_impact: "รายเดือน",
    annual_impact: "รายปี",
    simulate_scenario: "จำลองสถานการณ์",
    current_status: "สถานะปัจจุบัน",

    // Daily Tracker
    daily_tracker_title: "แทร็กเกอร์รายวัน",
    daily_tracker_subtitle: "บันทึกรายรับและติดตามผลงานรายวัน",
    add_entry: "เพิ่ม",
    total_revenue_daily: "รายรับรวม",
    daily_average: "เฉลี่ยรายวัน",
    avg_ticket_daily: "บิลเฉลี่ย",
    total_clients: "ลูกค้าทั้งหมด",
    receipts: "ใบเสร็จ",
    clients: "ลูกค้า",
    revenue_amount: "รายรับ",
    last_days_chart: "แนวโน้มวันล่าสุด",
    performance_score: "คะแนนผลงาน",
    weekly_summary: "สรุปรายสัปดาห์",
    break_even_line: "จุดคุ้มทุน",

    // Benchmark
    benchmark_title: "เกณฑ์มาตรฐานตลาด",
    benchmark_subtitle: "เปรียบเทียบ KPI ของคุณกับเกณฑ์มาตรฐานตลาดอิตาลี",
    select_type: "เลือกประเภท",
    your_value: "ค่าของคุณ",
    benchmark_value: "เกณฑ์มาตรฐาน",
    above_avg: "สูงกว่าค่าเฉลี่ย",
    below_avg: "ต่ำกว่าค่าเฉลี่ย",
    on_target: "ตรงเป้า",
    position_score: "คะแนนตำแหน่ง",

    // Operations
    operations_title: "การดำเนินงาน",
    operations_subtitle: "วิเคราะห์การดำเนินงานร้านอาหาร",
    staff_optimizer: "ปรับแต่งบุคลากร",
    menu_engineering: "วิศวกรรมเมนู",
    waste_tracker: "ติดตามของเสีย",

    // Month Comparison
    report_audit_title: "รายงาน & ตรวจสอบ",
    month_vs_month: "เดือนต่อเดือน",
    menu_audit: "ตรวจสอบเมนู",
    previous: "ก่อนหน้า",
    total_clients_label: "ลูกค้าทั้งหมด",
    expense_changes: "ค่าใช้จ่าย: การเปลี่ยนแปลงตามหมวดหมู่",
    no_expense_data: "ไม่มีค่าใช้จ่ายที่บันทึกสำหรับการเปรียบเทียบ",
    alert_changes: "การแจ้งเตือนการเปลี่ยนแปลง",
    insufficient_data: "ข้อมูลไม่เพียงพอสำหรับการเปรียบเทียบ",
    insufficient_data_desc: "กรอกรายรับรายวันและค่าใช้จ่ายเพื่อดูการเปรียบเทียบเดือนต่อเดือน",
    run_audit: "วิเคราะห์เมนู",
    audit_running: "กำลังวิเคราะห์...",
    audit_complete: "ตรวจสอบเมนูเสร็จสิ้น!",
    last_audit: "ตรวจสอบล่าสุด",
    dishes: "เมนู",
    avg_food_cost: "ต้นทุนอาหารเฉลี่ย",
    issues_found: "ปัญหาที่พบ",
    high_food_cost: "ต้นทุนอาหารสูง",
    low_margin: "กำไรต่ำ",
    audit_history: "ประวัติการตรวจสอบ",
    no_audit: "ไม่มีการตรวจสอบ",
    no_audit_desc: "วิเคราะห์ครั้งแรกเพื่อตรวจสอบเมนูของคุณ",
    issues: "ปัญหา",

    // PDF Reports
    pdf_reports: "รายงาน PDF",
    generate_daily_pdf: "สร้างรายงานรายวัน",
    generate_weekly_pdf: "สร้างรายงานรายสัปดาห์",
    generating_pdf: "กำลังสร้าง PDF...",
    pdf_ready: "รายงาน PDF พร้อมแล้ว!",
    download_pdf: "ดาวน์โหลด PDF",
    daily_report: "รายงานรายวัน",
    weekly_report: "รายงานรายสัปดาห์",
    report_generated: "สร้างรายงานแล้ว",

    // FAQ
    faq_title: "คำถามที่พบบ่อย",
    faq_subtitle: "คำตอบสำหรับคำถามที่พบบ่อยเกี่ยวกับ RistoMetrix",
    faq_stress_q: "สเตรสเทสต์ทำงานอย่างไร?",
    faq_stress_a: "สเตรสเทสต์วิเคราะห์ความยั่งยืนทางการเงินของร้านอาหาร กรอกข้อมูลจริง (บิลเฉลี่ย, ที่นั่ง, ต้นทุนบุคลากร, ค่าเช่า ฯลฯ) Sofia AI จะคำนวณจุดคุ้มทุน กำไรรายเดือนและรายปี พร้อมคำวินิจฉัย",
    faq_simulator_q: "ตัวจำลองสถานการณ์ทำงานอย่างไร?",
    faq_simulator_a: "ตัวจำลองให้คุณทำการวิเคราะห์ 'what-if' เริ่มจากข้อมูลสเตรสเทสต์แล้วเปลี่ยนพารามิเตอร์ Sofia จะคำนวณผลกระทบทางการเงิน",
    faq_daily_q: "ใช้แทร็กเกอร์รายวันอย่างไร?",
    faq_daily_a: "บันทึกรายรับ จำนวนใบเสร็จ และลูกค้าทุกวัน ระบบจะคำนวณบิลเฉลี่ยและติดตามผลงานอัตโนมัติ",
    faq_benchmark_q: "เกณฑ์มาตรฐานตลาดทำงานอย่างไร?",
    faq_benchmark_a: "เปรียบเทียบ KPI ของร้านอาหาร (ต้นทุนอาหาร, กำไร, บิลเฉลี่ย ฯลฯ) กับเกณฑ์มาตรฐานอุตสาหกรรมร้านอาหารอิตาลี",
    faq_menu_audit_q: "Menu Audit คืออะไร?",
    faq_menu_audit_a: "Menu Audit วิเคราะห์อัตโนมัติทุกเมนู: ตรวจสอบต้นทุนอาหาร กำไร และระบุปัญหา Sofia AI สร้างรายงานพร้อมคำแนะนำ",
    faq_menu_eng_q: "Menu Engineering คืออะไร?",
    faq_menu_eng_a: "Menu Engineering จำแนกเมนูเป็น 4 หมวด (Star, Puzzle, Plowhorse, Dog) ตามความนิยมและกำไร คุณจะได้รับคำแนะนำสำหรับแต่ละเมนู",
    faq_currency_q: "เปลี่ยนสกุลเงินอย่างไร?",
    faq_currency_a: "ไปที่ตั้งค่าและเลือกสกุลเงินที่ต้องการ สัญลักษณ์จะอัปเดตอัตโนมัติในทุกหน้า รองรับ 10 สกุลเงิน",
    faq_dark_q: "เปิดโหมดมืดอย่างไร?",
    faq_dark_a: "เปิดโหมดมืดจากปุ่มในแถบด้านข้าง (ไอคอนพระจันทร์/ดวงอาทิตย์) หรือจากหน้าตั้งค่า",
    faq_staff_q: "จัดการบุคลากรอย่างไร?",
    faq_staff_a: "ในส่วนบุคลากรสามารถเพิ่มพนักงานพร้อมเงินเดือน ชั่วโมงทำงาน แผนกและตำแหน่ง Staff Optimizer จะคำนวณจำนวนบุคลากรที่เหมาะสม",
    faq_pdf_q: "สร้างรายงาน PDF อย่างไร?",
    faq_pdf_a: "ในหน้ารายงาน & ตรวจสอบ สามารถสร้างรายงานรายวันหรือรายสัปดาห์ รายงานจะรวมสรุปผลงาน กราฟ และการวิเคราะห์ของ Sofia AI",

    // Expense Analysis & Alerts
    expense_analysis: "วิเคราะห์ค่าใช้จ่าย",
    expense_analysis_subtitle: "วิเคราะห์ต้นทุนขั้นสูง เกณฑ์ และผลกำไรตามพื้นที่",
    expense_alerts_tab: "แจ้งเตือนค่าใช้จ่าย",
    area_analysis_tab: "วิเคราะห์ตามพื้นที่",
    no_alerts: "ไม่มีการแจ้งเตือน",
    no_alerts_desc: "พารามิเตอร์ทั้งหมดอยู่ในเกณฑ์ ทำได้ดีมาก!",
    alert_severity_high: "วิกฤต",
    alert_severity_medium: "เตือน",
    threshold: "เกณฑ์",
    current_value: "ค่าปัจจุบัน",
    total_revenue_label: "รายรับรวม",
    total_expenses_label: "ค่าใช้จ่ายรวม",
    total_staff_cost_label: "ต้นทุนบุคลากร",
    net_margin_label: "กำไรสุทธิ",
    department_label: "แผนก",
    staff_cost_label: "ต้นทุนบุคลากร",
    estimated_revenue_label: "รายรับโดยประมาณ",
    profit_label: "กำไร",
    cost_pct_label: "ต้นทุน/รายรับ",
    area_status_ok: "ปกติ",
    area_status_warning: "เตือน",
    area_status_critical: "วิกฤต",
    area_status_no_revenue: "ไม่มียอดขาย",
    no_area_data: "ไม่มีข้อมูลพื้นที่",
    no_area_data_desc: "กรอกยอดขายตามหมวดหมู่ในแทร็กเกอร์รายวันและเพิ่มบุคลากรเพื่อวิเคราะห์พื้นที่",
    category_sales_title: "ยอดขายตามหมวดหมู่",
    category_sales_desc: "บันทึกจำนวนเมนูที่ขายตามหมวดหมู่",
    dish_sales_title: "ยอดขายตามเมนู",
    dish_sales_desc: "จำนวนที่ขายต่อเมนู",
    dishes_sold: "จานที่ขาย",
    revenue_from_dishes: "รายได้จากเมนู",
    sold: "ขายแล้ว",
    no_menu_items_title: "ไม่มีเมนูอาหาร",
    no_menu_items_desc: "เพื่อติดตามยอดขายรายเมนู กรุณาเพิ่มเมนูอาหารก่อน",
    go_to_menu: "ไปที่เมนู",
    qty_sold: "จำนวนที่ขาย",
    daily_detail: "รายละเอียดรายวัน",
    weekly_summary_title: "สรุปรายสัปดาห์",
    history_title: "ประวัติการบันทึก",
    start_tracking: "เริ่มติดตาม",
    start_tracking_desc: "เริ่มกรอกรายรับรายวันเพื่อติดตามผลงาน",
    avg_ticket_label: "บิลเฉลี่ย",
    spend_per_client: "ค่าใช้จ่าย/ลูกค้า",
    of_average: "ของค่าเฉลี่ย",
    clients_label: "ลูกค้า",
    ticket_label: "บิล",
    below_breakeven: "ต่ำกว่าจุดคุ้มทุน",
    avg_daily_label: "เฉลี่ย/วัน",
    days_recorded: "วัน",
    date_range_label: "ช่วงวันที่",
    range_mode_desc: "ข้อมูลจะถูกป้อนสำหรับทุกวันในช่วงที่เลือก",
    date_from: "วันที่เริ่มต้น",
    date_to: "วันที่สิ้นสุด",
    days_label: "วัน",
    days_saved: "วันที่บันทึก",
    date_range_error: "วันเริ่มต้นต้องก่อนวันสิ้นสุด",
    date_range_too_long: "ช่วงสูงสุด: 90 วัน",
    income_label: "รายรับ",
    receipts_label: "ใบเสร็จ",
    avg_ticket_col: "บิลเฉลี่ย",
    staff_members_label: "สมาชิก",

    // Restaurant Detail
    months_of_data: "เดือนของข้อมูล",
    financial_data: "ข้อมูลทางการเงิน",
    export_csv: "ส่งออก CSV",
    add_monthly_data: "เพิ่มข้อมูลรายเดือน",
    add_financial_data: "เพิ่มข้อมูลทางการเงิน",
    month_yyyy_mm: "เดือน (YYYY-MM)",
    rent: "ค่าเช่า",
    utilities: "สาธารณูปโภค",
    other_costs: "ค่าใช้จ่ายอื่น",
    revenue_profit_trend: "แนวโน้มรายรับและกำไร",
    cost_breakdown: "รายละเอียดต้นทุน (เดือนล่าสุด)",
    month_label: "เดือน",
    reviews_by_platform: "รีวิวตามแพลตฟอร์ม",
    recent_reviews: "รีวิวล่าสุด",
    reviews_count: "รีวิว",

    // Team Page
    team_subtitle: "จัดการสมาชิกทีมและสิทธิ์การเข้าถึง",
    edit_member: "แก้ไขสมาชิก",
    new_member: "สมาชิกทีมใหม่",
    member_subtitle: "สร้างสมาชิกพร้อมสิทธิ์เฉพาะ",
    enter_password: "กรอกรหัสผ่าน",
    member_updated: "อัปเดตสมาชิกแล้ว!",
    member_added: "เพิ่มสมาชิกในทีมแล้ว!",
    member_deleted: "ลบสมาชิกแล้ว",
    confirm_delete_member: "ลบสมาชิกทีมนี้?",
    name_label: "ชื่อ",
    email_label: "อีเมล",
    password_label: "รหัสผ่าน",
    role_label: "ตำแหน่ง",
    role_viewer: "ดูอย่างเดียว",
    role_viewer_desc: "ดูอย่างเดียว - สามารถดูได้เท่านั้น",
    role_editor: "ผู้แก้ไข",
    role_editor_desc: "ผู้แก้ไข - สามารถแก้ไขเมนู บุคลากร ค่าใช้จ่าย",
    role_admin: "ผู้ดูแลระบบ",
    role_admin_desc: "ผู้ดูแลระบบ - เข้าถึงได้ทั้งหมด",
    restaurant_access: "การเข้าถึงร้านอาหาร",
    restaurant_access_desc: "เลือกร้านที่สามารถเข้าถึงได้ (ว่าง = ทั้งหมด)",
    no_team_members: "ไม่มีสมาชิกทีม",
    no_team_members_desc: "เพิ่มสมาชิกเพื่อให้ทีมเข้าถึงด้วยสิทธิ์ที่กำหนดเอง",
    add_first_member: "เพิ่มสมาชิกคนแรก",
    restaurants_count: "ร้านอาหาร",

    // Alerts Page
    alerts_title: "การแจ้งเตือน & แจ้งข่าวสาร",
    alerts_subtitle: "กำหนดค่าการแจ้งเตือนอัตโนมัติและดูการแจ้งข่าวสาร",
    alert_settings_desc: "กำหนดเกณฑ์สำหรับการแจ้งเตือนอัตโนมัติ",
    alert_if_above: "แจ้งเตือนถ้าสูงกว่า",
    alert_if_below: "แจ้งเตือนถ้าต่ำกว่า",
    in_app_notifications_desc: "แสดงการแจ้งเตือนในแดชบอร์ด",
    email_notifications_desc: "รับการแจ้งเตือนทางอีเมล",
    alerts_list: "การแจ้งเตือน",
    alerts_history: "ประวัติการแจ้งเตือน",
    mark_all_read: "ทำเครื่องหมายอ่านทั้งหมด",
    value_label: "ค่า",
    threshold_label: "เกณฑ์",
    no_alerts_history: "การแจ้งเตือนจะปรากฏที่นี่เมื่อพารามิเตอร์ร้านอาหารของคุณเกินเกณฑ์",

    // Login Page
    welcome_back: "ยินดีต้อนรับกลับ",
    login_subtitle: "เข้าสู่ระบบเพื่อจัดการร้านอาหาร",
    logging_in: "กำลังเข้าสู่ระบบ...",
    login_error: "เกิดข้อผิดพลาดในการเข้าสู่ระบบ",
    create_account: "สร้างบัญชี",
    register_subtitle: "เริ่มติดตามผลงานร้านอาหาร",
    full_name: "ชื่อเต็ม",
    registering: "กำลังลงทะเบียน...",
    register_error: "เกิดข้อผิดพลาดในการลงทะเบียน",
    hero_title: "จัดการผลงานร้านอาหารของคุณ",
    hero_revenue: "วิเคราะห์รายรับและต้นทุน",
    hero_reviews: "ติดตามรีวิว",
    hero_multi: "เปรียบเทียบหลายสาขา",
    hero_ai: "คำแนะนำ AI",

    // Integrations Page
    syncing: "กำลังซิงค์...",
    sync: "ซิงค์",
    import_csv: "นำเข้า CSV",
    import_from_csv: "นำเข้าจาก CSV",
    import_reviews: "นำเข้ารีวิว",
    import_manual_review: "เพิ่มรีวิวด้วยตนเอง",
    import_review_title: "นำเข้ารีวิวด้วยตนเอง",
    import_review_desc: "กรอกข้อมูลรีวิว",
    reviews_imported: "รีวิวที่นำเข้า",
    platform_label: "แพลตฟอร์ม",
    platform_origin: "แพลตฟอร์มต้นทาง",
    upload_csv: "อัปโหลดไฟล์ CSV",
    paste_csv: "หรือวางเนื้อหา CSV",
    csv_format: "รูปแบบ CSV: ผู้เขียน, คะแนน (1-5), วันที่ (YYYY-MM-DD), ข้อความ",
    importing: "กำลังนำเข้า...",
    import_btn: "นำเข้า",
    import_error: "เกิดข้อผิดพลาดในการนำเข้า",
    import_csv_error: "เกิดข้อผิดพลาดในการนำเข้า CSV",
    author_label: "ผู้เขียน",
    text_label: "ข้อความ",
    email_alerts_title: "แจ้งเตือนอีเมล",
    email_alerts_desc: "รับการแจ้งเตือนอัตโนมัติเมื่อตัวชี้วัดเกินเกณฑ์",
    send_test_email: "ส่งอีเมลทดสอบ",
    saving_settings: "กำลังบันทึก...",
    save_all_settings: "บันทึกการตั้งค่าทั้งหมด",
    google_how_to: "วิธีเชื่อมต่อ Google Reviews:",
    tripadvisor_no_api: "TripAdvisor ไม่มี API สาธารณะ",
    thefork_no_api: "TheFork ไม่มี API สาธารณะ",

    // Restaurants Page
    select_placeholder: "เลือก...",

    // Reviews Page
    select_restaurant: "เลือกร้านอาหาร",

    // Competitors Page
    competitor_data_desc: "กรอกข้อมูลคู่แข่งเพื่อเปรียบเทียบ",
    strengths_placeholder: "สิ่งที่เขาทำได้ดี...",
    weaknesses_placeholder: "จุดที่เขาอ่อนแอ...",
    overall_score: "คะแนนโดยรวม",
    your_price: "ราคาของคุณ",

    // Operations/Waste
    avg_margin_label: "กำไรเฉลี่ย",
    avg_price_label: "ราคาเฉลี่ย",
    add_menu_items_matrix: "เพิ่มเมนูเพื่อดูเมทริกซ์",
    staff_optimization: "ปรับแต่งบุคลากร",
    total_needed: "จำนวนที่ต้องการ",
    staff_cost_day: "ต้นทุนบุคลากร/วัน",
    cost_per_cover: "ต้นทุนต่อที่นั่ง",

    // Viability Test
    enter_data: "กรอกข้อมูลร้านอาหาร",
    employees_label: "พนักงาน",
    avg_cost_label: "ต้นทุนเฉลี่ย",
    covers_month: "ที่นั่ง/เดือน",
    scenario_desc: "จะเกิดอะไรขึ้นถ้าเปลี่ยนบางอย่าง? กรอกเฉพาะค่าที่ต้องการเปลี่ยน",

    // Expenses
    all_months: "ทุกเดือน",

    // Auto Reports & Audit
    auto_reports: "รายงานอัตโนมัติ",
    auto_reports_desc: "กำหนดค่าการสร้างรายงาน PDF อัตโนมัติ",
    auto_reports_frequency: "ความถี่",
    auto_reports_daily: "รายวัน",
    auto_reports_weekly: "รายสัปดาห์",
    auto_reports_disabled: "ปิดใช้งาน",
    auto_reports_saved: "บันทึกการตั้งค่ารายงานอัตโนมัติแล้ว",
    auto_audit: "ตรวจสอบเมนูอัตโนมัติ",
    auto_audit_desc: "วิเคราะห์ผลงานเมนูอัตโนมัติรายเดือน",
    auto_audit_enabled: "เปิดใช้ตรวจสอบอัตโนมัติ",
    auto_audit_disabled: "ปิดใช้ตรวจสอบอัตโนมัติ",
    last_auto_report: "รายงานอัตโนมัติล่าสุด",
    last_auto_audit: "ตรวจสอบอัตโนมัติล่าสุด",
    never: "ไม่เคย",
    download_report: "ดาวน์โหลดรายงาน",
    auto_reports_list: "รายงานที่สร้างแล้ว",
    no_auto_reports: "ไม่มีรายงานอัตโนมัติ",

    // Food Cost Page
    food_cost_title: "ควบคุมต้นทุนอาหาร",
    suppliers_tab: "ผู้จัดหา",
    ingredients_tab: "วัตถุดิบ",
    invoices_tab: "ใบแจ้งหนี้",
    monthly_fc_tab: "FC รายเดือน",
    monthly_area_tab: "FC ตามพื้นที่",
    credit_notes_tab: "ใบลดหนี้",
    scan_invoice: "สแกนใบแจ้งหนี้",
    invoice_analyzed: "วิเคราะห์ใบแจ้งหนี้สำเร็จ",
    invoice_saved: "บันทึกใบแจ้งหนี้แล้ว!",
    add_supplier: "เพิ่มผู้จัดหา",
    supplier_name: "ชื่อผู้จัดหา",
    contact: "ติดต่อ",
    add_ingredient: "เพิ่มวัตถุดิบ",
    ingredient_name: "ชื่อวัตถุดิบ",
    unit: "หน่วย",
    packing: "บรรจุภัณฑ์",
    no_suppliers: "ไม่มีผู้จัดหา",
    no_ingredients: "ไม่มีวัตถุดิบ",
    no_invoices: "ไม่มีใบแจ้งหนี้",
    total_purchases: "การซื้อทั้งหมด",
    avg_food_cost_pct: "FC% เฉลี่ย",
    real_vs_theoretical: "จริง vs ทฤษฎี",
    theoretical: "ทฤษฎี",
    real: "จริง",
    area: "พื้นที่",

    // Cash Flow Simulator
    cash_flow_title: "ตัวจำลองกระแสเงินสด",
    cash_flow_page_title: "กระแสเงินสด",
    revenue_label_full: "รายรับ",
    staff_label_full: "บุคลากร",
    rent_label: "ค่าเช่า",
    food_cost_label: "ต้นทุนอาหาร",
    marketing_label: "การตลาด",
    utilities_label: "สาธารณูปโภค",
    other_label: "อื่นๆ",
    ebitda_label: "EBITDA",
    margin_label: "กำไร",
    base_scenario_label: "สถานการณ์ฐาน",
    new_scenario_label: "สถานการณ์ใหม่",
    impact_label: "ผลกระทบ",
    monthly_label: "รายเดือน",
    annual_label: "รายปี",
    add_scenario: "เพิ่มสถานการณ์",
    quick_scenarios: "สถานการณ์ด่วน",
    custom_scenario: "สถานการณ์กำหนดเอง",
    revenue_change: "เปลี่ยนแปลงรายรับ",
    add_staff: "เพิ่มบุคลากร",
    remove_staff: "ลดบุคลากร",
    cost_per_month: "ต้นทุน/เดือน",
    change_rent: "เปลี่ยนค่าเช่า",
    delta: "ผลต่าง",
    food_cost_change: "เปลี่ยนแปลงต้นทุนอาหาร",
    amount: "จำนวน",
    run_simulation_btn: "จำลอง",
    simulating: "กำลังจำลอง...",
    revenue_vs_costs: "รายรับ vs ต้นทุนรายวัน",
    cost_breakdown_label: "รายละเอียดต้นทุน",

    // Profit & Loss
    profit_loss_title: "งบกำไรขาดทุน",
    gross_revenue_label: "รายรับรวม",
    net_revenue: "รายรับสุทธิ",
    food_cost_pl: "วัตถุดิบ",
    gross_margin: "กำไรขั้นต้น",
    staff_cost_pl: "ต้นทุนบุคลากร",
    operating_margin: "กำไรจากการดำเนินงาน",
    rent_pl: "ค่าเช่า",
    utilities_pl: "สาธารณูปโภค",
    marketing_pl: "การตลาด",
    other_expenses_pl: "ค่าใช้จ่ายอื่น",
    iva_label: "VAT",
    vat_label: "VAT",
    vat_settlement: "การชำระ VAT",
    sales_vat: "VAT ขาย (เดบิต)",
    purchase_vat: "VAT ซื้อ (เครดิต)",
    delta_vat: "VAT ที่ต้องจ่าย",
    no_invoices_vat: "ไม่มีใบแจ้งหนี้ที่บันทึกสำหรับเดือนนี้ สแกนใบแจ้งหนี้เพื่อคำนวณ VAT ซื้อจริง",
    net_amount: "ยอดสุทธิ",
    quarterly_view: "รายไตรมาส",
    cumulative_view: "สะสม",
    kpi_benchmarks: "KPI vs เกณฑ์มาตรฐาน",
    benchmark: "เกณฑ์มาตรฐาน",
    your_value_label: "ค่าของคุณ",

    // Staff Analysis
    staff_analysis_title: "วิเคราะห์บุคลากร",
    revenue_per_employee: "รายรับ/พนักงาน",
    cost_revenue_ratio: "ต้นทุน/รายรับ",
    revenue_30d: "รายรับ 30 วัน",
    pct_revenue: "% รายรับ",

    // Restaurant Detail
    use_existing_costs: "ใช้ต้นทุนที่มีอยู่ (บุคลากร + ค่าใช้จ่าย)",
    gross_revenue_short: "รายรับรวม",

    // Comparison
    total_revenue_compare: "รายรับรวม",
    restaurants_label: "ร้านอาหาร",
    health_score_label: "คะแนนสุขภาพร้านอาหาร",

    // Dashboard extra
    food_cost_health: "ต้นทุนอาหาร",
    labor_cost_health: "บุคลากร",
    margin_health: "กำไร",

    // Menu Engineering
    menu_eng_title: "วิศวกรรมเมนู",
    stars: "Stars",
    puzzles: "Puzzles",
    plowhorses: "Plowhorses",
    dogs: "Dogs",
    popularity: "ความนิยม",
    profitability: "กำไร",
    high: "สูง",
    low: "ต่ำ",
    keep_promote: "รักษาและโปรโมท",
    increase_price: "เพิ่มราคา",
    reduce_cost: "ลดต้นทุน",
    consider_removing: "พิจารณาเอาออก",

    // Viability Test
    viability_title: "สเตรสเทสต์ & ตัวจำลอง",
    kitchen: "ครัว",
    pizzeria: "พิซซ่า",
    bar: "บาร์",

    // Billing
    annual_billing: "รายปี",
    monthly_billing: "รายเดือน",
    payment_success: "ชำระเงินสำเร็จ",
    payment_cancel: "ยกเลิกการชำระเงิน",
    plan_active: "แผนที่ใช้งาน",
    upgrade: "อัปเกรด",
    current_plan: "แผนปัจจุบัน",

    // Login extra
    welcome_back_title: "ยินดีต้อนรับกลับ",
    register_title: "สร้างบัญชี",

    // SuperAdmin
    users_label: "ผู้ใช้",
    total_users: "ผู้ใช้ทั้งหมด",
    active_users: "ผู้ใช้ที่ใช้งาน",
    total_restaurants: "ร้านอาหารทั้งหมด",

    // Credit Notes
    credit_notes: "ใบลดหนี้",
    reason: "เหตุผล",

    // Per month
    per_month: "/เดือน",
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  // Thai temporarily disabled - if a user has 'th' stored, fall back to 'en'
  const stored = localStorage.getItem('gm_lang');
  const initial = stored === 'th' ? 'en' : (stored || 'it');
  const [lang, setLang] = useState(initial);

  useEffect(() => {
    localStorage.setItem('gm_lang', lang);
  }, [lang]);

  const t = (key) => translations[lang]?.[key] || translations['it']?.[key] || key;
  const tx = (itText, enText, thText) => lang === 'it' ? itText : lang === 'th' ? (thText || enText) : enText;
  // Toggle now cycles only between IT and EN (TH disabled until re-enabled)
  const toggleLang = () => setLang(prev => prev === 'it' ? 'en' : 'it');

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, tx, toggleLang }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
